import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass, initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine, initMetadataForLambda3af3he42mmnh as initMetadataForLambda, initMetadataForObject1cxne3s9w65el as initMetadataForObject, initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion, initMetadataForInterface1egvbzx539z91 as initMetadataForInterface, protoOf180f3jzyo7rfj as protoOf, get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED, noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException, Unit_instance14hm69wy3kr8u as Unit_instance, THROW_CCE2g6jy02ryeudk as THROW_CCE, isInterface3d6p8outrmvmk as isInterface, KtMutableMap1kqeifoi36kpz as KtMutableMap, Companion_getInstance1mc3g3aij23my as Companion_getInstance_16$1, toDuration7gy6v749ektt as toDuration, DurationUnit_MICROSECONDS_getInstance3fc8lh41ujep2 as DurationUnit_MICROSECONDS_getInstance, Exceptiondt2hlxn7j7vw as Exception, VOID7hggqo3abtya as VOID, Long2qws0ah9gnpki as Long, toString30pk9tzaqopn as toString_0, getStringHashCode26igk1bx568vk as getStringHashCode, hashCodeq5arwsb9dgti as hashCode, equals2au1ep9vhcato as equals, toString1pkumu07cwy4m as toString_1, firstOrNullf6vlo6vdgu1e as firstOrNull, objectCreate1ve4bgxiu4x98 as objectCreate, createKType1lgox3mzhchp5 as createKType, getKClass1s3j9wy1cofik as getKClass, getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode, LazyThreadSafetyMode_PUBLICATION_getInstance2l411fkf5jrbp as LazyThreadSafetyMode_PUBLICATION_getInstance, lazy1261dae0bgscp as lazy, getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef, KProperty1ca4yb4wlo496 as KProperty1, defineProp3hxgpk2knu2px as defineProp, CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl, Exception_init_$Init$25rnrjp6anyxk as Exception_init_$Init$, captureStack1fzi4aczwc4hg as captureStack, LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$, arrayOf1akklvh2at202 as arrayOf, throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException, plus310ted5e4i90h as plus_0, Char__rangeTo_impl_tkncvp1xeq9dxokim1v as Char__rangeTo_impl_tkncvp, plus39kp8wyage607 as plus_1, ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0, random234odtwlu7lq2 as random, Default_getInstancexco526sx0ut9 as Default_getInstance, Char19o2r8palgjof as Char, joinToString1cxrrlmo0chqs as joinToString_0, lazy2hsh8ze7j6ikd as lazy_0, _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx } from './kotlin-kotlin-stdlib.js';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope, delayko55i6ibvfeo as delay, withTimeoutOrNullod8v51lxlhk as withTimeoutOrNull, launch1c91vkjzdi9sd as launch, promise1ky6tawqaxbt4 as promise, Mutex16li1l0asjv17 as Mutex, CoroutineScopelux7s7zphw7e as CoroutineScope_0, SupervisorJobythnfxkr3jxc as SupervisorJob, awaitopqeg9l1dqx0 as await_0 } from './kotlinx-coroutines-core.js';
import { StringSerializer_getInstance2kpn94uehvuc4 as StringSerializer_getInstance, UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$, get_nullable197rfua9r7fsz as get_nullable, IntSerializer_getInstance1qqxumiddm0tw as IntSerializer_getInstance, serializer1i4e9ym37oxmo as serializer, KSerializerzf77vz1967fq as KSerializer, BooleanSerializer_getInstance3t92d2vyp8fnb as BooleanSerializer_getInstance, ObjectSerializer_init_$Create$tux9aj50xrk1 as ObjectSerializer_init_$Create$, SealedClassSerializer_init_$Create$1vd2fpfo2lck9 as SealedClassSerializer_init_$Create$, typeParametersSerializers2likxjr48tr7y as typeParametersSerializers, PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor, throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException, PolymorphicSerializer_init_$Create$1iticqgwls3rt as PolymorphicSerializer_init_$Create$, GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer, SerializerFactory1qv9hivitncuv as SerializerFactory, SerializersModuleBuilderfxsfdohcdipc as SerializersModuleBuilder } from './kotlinx-serialization-kotlinx-serialization-core.js';
import { JsonContentPolymorphicSerializer1zt3sp8asmujz as JsonContentPolymorphicSerializer, Jsonsmkyu9xjl7fv as Json_0 } from './kotlinx-serialization-kotlinx-serialization-json.js';

//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(DefaultIpcHostCommands, 'DefaultIpcHostCommands', VOID, VOID, VOID, [1]);
initMetadataForClass(IpcBaseRequestHandler, 'IpcBaseRequestHandler', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($handleRequestCOROUTINE$0, CoroutineImpl);
initMetadataForCoroutine($delegateCOROUTINE$1, CoroutineImpl);
initMetadataForClass(IpcHostRequestHandler, 'IpcHostRequestHandler', VOID, IpcBaseRequestHandler, VOID, [1]);
initMetadataForCoroutine($handleRequestCOROUTINE$2, CoroutineImpl);
initMetadataForCoroutine($delegateCOROUTINE$3, CoroutineImpl);
initMetadataForClass(IpcClientRequestHandler, 'IpcClientRequestHandler', VOID, IpcBaseRequestHandler, VOID, [1]);
initMetadataForLambda(IpcConnection$request$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$request$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$request$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda_3, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$onReceive$slambda_5, CoroutineImpl, VOID, [1]);
initMetadataForLambda(IpcConnection$executeRequest$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($requestCOROUTINE$4, CoroutineImpl);
initMetadataForCoroutine($executeRequestCOROUTINE$5, CoroutineImpl);
initMetadataForClass(IpcConnection, 'IpcConnection', VOID, VOID, VOID, [1, 2]);
initMetadataForClass(IpcDecodeFrameResult, 'IpcDecodeFrameResult');
initMetadataForObject(Success, 'Success', VOID, IpcDecodeFrameResult);
initMetadataForClass(Failed, 'Failed', VOID, IpcDecodeFrameResult);
initMetadataForClass(IpcErrorException, 'IpcErrorException', VOID, Exception);
initMetadataForClass(IpcHost, 'IpcHost');
initMetadataForClass(DefaultIpcHostConnection, 'DefaultIpcHostConnection');
initMetadataForClass(IpcTxToWebChannel, 'IpcTxToWebChannel');
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcFrame, 'IpcFrame', VOID, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance
});
initMetadataForObject(IpcJson, 'IpcJson');
initMetadataForObject(MapToUnknownRequestSerializer, 'MapToUnknownRequestSerializer', VOID, JsonContentPolymorphicSerializer);
initMetadataForObject(MapToUnknownErrorSerializer, 'MapToUnknownErrorSerializer', VOID, JsonContentPolymorphicSerializer);
initMetadataForObject(MapToUnknownEndResultSerializer, 'MapToUnknownEndResultSerializer', VOID, JsonContentPolymorphicSerializer);
initMetadataForCompanion(Companion_0, VOID, [SerializerFactory]);
initMetadataForClass($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcResult, 'IpcResult', VOID, VOID, VOID, VOID, VOID, {
  0: Companion_getInstance_3
});
initMetadataForClass(Success_0, 'Success', VOID, IpcResult, VOID, VOID, VOID, {
  0: Companion_getInstance_1
});
initMetadataForClass(Failure, 'Failure', VOID, IpcResult, VOID, VOID, VOID, {
  0: $serializer_getInstance_0
});
initMetadataForCompanion(Companion_2, VOID, [SerializerFactory]);
initMetadataForCoroutine($useCOROUTINE$6, CoroutineImpl);
initMetadataForClass(MutexedMap, 'MutexedMap', MutexedMap, VOID, VOID, [1]);
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ConnectArgs, 'ConnectArgs', VOID, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_1
});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(EndResult, 'EndResult', VOID, VOID, VOID, VOID, VOID, {
  0: Companion_getInstance_6
});
initMetadataForObject(GoBack, 'GoBack', VOID, EndResult, [EndResult, SerializerFactory], VOID, VOID, {
  0: GoBack_getInstance
});
initMetadataForClass(GoHome, 'GoHome', VOID, EndResult, VOID, VOID, VOID, {
  0: $serializer_getInstance_2
});
initMetadataForObject(Unknown, 'Unknown', VOID, EndResult, [EndResult, SerializerFactory], VOID, VOID, {
  0: Unknown_getInstance
});
initMetadataForCompanion(Companion_5, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_6);
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SignPayloadData, 'SignPayloadData', VOID, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_3
});
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_8);
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_9);
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_10);
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcError, 'IpcError', VOID, VOID, VOID, VOID, VOID, {
  0: Companion_getInstance_15
});
initMetadataForClass(Interop, 'Interop', VOID, IpcError, VOID, VOID, VOID, {
  0: Companion_getInstance_12
});
initMetadataForClass(InvalidRequest, 'InvalidRequest', VOID, Interop, VOID, VOID, VOID, {
  0: $serializer_getInstance_5
});
initMetadataForClass(Timeout, 'Timeout', VOID, Interop, VOID, VOID, VOID, {
  0: $serializer_getInstance_6
});
initMetadataForClass(HandlerException, 'HandlerException', VOID, Interop, VOID, VOID, VOID, {
  0: $serializer_getInstance_7
});
initMetadataForObject(Unsupported, 'Unsupported', VOID, IpcError, [IpcError, SerializerFactory], VOID, VOID, {
  0: Unsupported_getInstance
});
initMetadataForObject(UnknownResponseError, 'UnknownResponseError', VOID, Interop, [Interop, SerializerFactory], VOID, VOID, {
  0: UnknownResponseError_getInstance
});
initMetadataForCompanion(Companion_11, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_12);
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Network, 'Network', VOID, IpcError, VOID, VOID, VOID, {
  0: Companion_getInstance_14
});
initMetadataForClass(Unknown_0, 'Unknown', VOID, Network, VOID, VOID, VOID, {
  0: $serializer_getInstance_8
});
initMetadataForCompanion(Companion_13, VOID, [SerializerFactory]);
initMetadataForClass(Generic, 'Generic', VOID, IpcError, VOID, VOID, VOID, {
  0: $serializer_getInstance_4
});
initMetadataForCompanion(Companion_14, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_15);
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AppConnectInfo, 'AppConnectInfo', VOID, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_9
});
initMetadataForCompanion(Companion_16);
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AppDebugInfo, 'AppDebugInfo', VOID, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_10
});
initMetadataForCompanion(Companion_17);
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AppFeatureManifest, 'AppFeatureManifest', AppFeatureManifest, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_11
});
initMetadataForCompanion(Companion_18);
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(BiometricFeatures, 'BiometricFeatures', BiometricFeatures, VOID, VOID, VOID, VOID, {
  0: $serializer_getInstance_12
});
initMetadataForCompanion(Companion_19);
initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(IpcReply_0, 'IpcReply', VOID, VOID, VOID, VOID, VOID, {
  0: Companion_getInstance_24
});
initMetadataForClass(IpcConnectReply, 'IpcConnectReply', VOID, VOID, [IpcReply_0], VOID, VOID, {
  0: $serializer_getInstance_13
});
initMetadataForCompanion(Companion_20);
initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcDigSigAvailabilityReply, 'IpcDigSigAvailabilityReply', VOID, VOID, [IpcReply_0], VOID, VOID, {
  0: $serializer_getInstance_14
});
initMetadataForCompanion(Companion_21);
initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcDigSigSignPayloadReply, 'IpcDigSigSignPayloadReply', VOID, VOID, [IpcReply_0], VOID, VOID, {
  0: $serializer_getInstance_15
});
initMetadataForCompanion(Companion_22);
initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcPingReply, 'IpcPingReply', VOID, VOID, [IpcReply_0], VOID, VOID, {
  0: $serializer_getInstance_16
});
initMetadataForCompanion(Companion_23, VOID, [SerializerFactory]);
initMetadataForObject(IpcVoid_0, 'IpcVoid', VOID, VOID, [IpcReply_0, SerializerFactory], VOID, VOID, {
  0: IpcVoid_getInstance
});
initMetadataForCompanion(Companion_24);
initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcRequest, 'IpcRequest', VOID, VOID, VOID, VOID, VOID, {
  0: Companion_getInstance_28
});
initMetadataForClass(AppCmd, 'AppCmd', VOID, IpcRequest, VOID, VOID, VOID, {
  0: Companion_getInstance_26
});
initMetadataForClass(Ping, 'Ping', VOID, AppCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_17
});
initMetadataForCompanion(Companion_25, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_26);
initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(IpcDebugErrorRequest, 'IpcDebugErrorRequest', VOID, IpcRequest, VOID, VOID, VOID, {
  0: $serializer_getInstance_18
});
initMetadataForCompanion(Companion_27, VOID, [SerializerFactory]);
initMetadataForObject(UnknownRequest, 'UnknownRequest', VOID, IpcRequest, [IpcRequest, SerializerFactory], VOID, VOID, {
  0: UnknownRequest_getInstance
});
initMetadataForCompanion(Companion_28);
initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_29);
initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_30);
initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_31);
initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_32);
initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(WebCmd, 'WebCmd', VOID, IpcRequest, VOID, VOID, VOID, {
  0: Companion_getInstance_34
});
initMetadataForClass(BeginSession, 'BeginSession', VOID, WebCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_19
});
initMetadataForClass(Connect, 'Connect', VOID, WebCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_20
});
initMetadataForClass(EndSession, 'EndSession', VOID, WebCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_21
});
initMetadataForClass(Ping_0, 'Ping', VOID, WebCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_22
});
initMetadataForObject(GetDigSigAvailability, 'GetDigSigAvailability', VOID, WebCmd, [WebCmd, SerializerFactory], VOID, VOID, {
  0: GetDigSigAvailability_getInstance
});
initMetadataForObject(StartDigSigEnrollment, 'StartDigSigEnrollment', VOID, WebCmd, [WebCmd, SerializerFactory], VOID, VOID, {
  0: StartDigSigEnrollment_getInstance
});
initMetadataForClass(GetSignedPayload, 'GetSignedPayload', VOID, WebCmd, VOID, VOID, VOID, {
  0: $serializer_getInstance_23
});
initMetadataForCompanion(Companion_33, VOID, [SerializerFactory]);
initMetadataForLambda(DefaultWebCommands$beginSession$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebCommands$ping$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebCommands$generateError$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebCommands$endSession$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebCommands$getDigSigAvailability$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebCommands$getDigSigSignature$slambda, CoroutineImpl, VOID, [1]);
function endSession(result, $super) {
  result = result === VOID ? GoBack_getInstance() : result;
  return this.d29(result);
}
initMetadataForInterface(WebCommands, 'WebCommands');
initMetadataForClass(DefaultWebCommands, 'DefaultWebCommands', VOID, VOID, [WebCommands]);
initMetadataForInterface(JsIpcConnection, 'JsIpcConnection');
initMetadataForClass(DefaultJsIpcConnection, 'DefaultJsIpcConnection', VOID, VOID, [JsIpcConnection]);
initMetadataForClass(JsReceiveFromNativeChannel, 'JsReceiveFromNativeChannel');
initMetadataForClass(JsSendToNativeChannel, 'JsSendToNativeChannel', JsSendToNativeChannel);
initMetadataForLambda(WebIpcClient$connect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(WebIpcClient, 'WebIpcClient', WebIpcClient);
initMetadataForCoroutine($onPingCOROUTINE$7, CoroutineImpl);
initMetadataForClass(WebIpcFakeApp$txChannel$1, VOID, VOID, IpcTxToWebChannel);
initMetadataForClass(WebIpcFakeApp$requestHandler$1, VOID, VOID, VOID, VOID, [1, 0]);
initMetadataForClass(WebIpcFakeApp, 'WebIpcFakeApp', WebIpcFakeApp);
initMetadataForClass(WebIpcHandlerPromiseAdapter, 'WebIpcHandlerPromiseAdapter', VOID, VOID, VOID, [1, 0]);
//endregion
function DefaultIpcHostCommands(connection) {
  this.k1s_1 = connection;
}
protoOf(DefaultIpcHostCommands).l1s = function (msg, $completion) {
  return this.k1s_1.s1s(new Ping(msg), $completion);
};
function IpcBaseRequestHandler() {}
protoOf(IpcBaseRequestHandler).t1s = function (req, $completion) {
  var tmp;
  if (req instanceof IpcDebugErrorRequest) {
    tmp = new Failure(req.u1s_1);
  } else {
    tmp = null;
  }
  var response = tmp;
  if (response == null) return new Failure(Unsupported_getInstance());
  return response;
};
function delegate($this, cmd, $completion) {
  var tmp = new $delegateCOROUTINE$1($this, cmd, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
}
function $handleRequestCOROUTINE$0(_this__u8e3s4, req, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.p1t_1 = _this__u8e3s4;
  this.q1t_1 = req;
}
protoOf($handleRequestCOROUTINE$0).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 4;
          this.r1t_1 = this.q1t_1;
          var tmp_0 = this.r1t_1;
          if (tmp_0 instanceof WebCmd) {
            this.t7_1 = 2;
            suspendResult = delegate(this.p1t_1, this.q1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            var tmp_1 = this.r1t_1;
            if (tmp_1 instanceof AppCmd) {
              this.s1t_1 = new Failure(new InvalidRequest('App command sent to app handler. Make sure the request inherits from the correct class.'));
              this.t7_1 = 3;
              continue $sm;
            } else {
              this.t7_1 = 1;
              suspendResult = protoOf(IpcBaseRequestHandler).t1s.call(this.p1t_1, this.q1t_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          }
        case 1:
          this.s1t_1 = suspendResult;
          this.t7_1 = 3;
          continue $sm;
        case 2:
          this.s1t_1 = suspendResult;
          this.t7_1 = 3;
          continue $sm;
        case 3:
          return this.s1t_1;
        case 4:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 4) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function $delegateCOROUTINE$1(_this__u8e3s4, cmd, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.d1t_1 = _this__u8e3s4;
  this.e1t_1 = cmd;
}
protoOf($delegateCOROUTINE$1).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 7;
          this.f1t_1 = this.e1t_1;
          var tmp_0 = this.f1t_1;
          if (tmp_0 instanceof Connect) {
            this.g1t_1 = new Success_0(new IpcConnectReply(this.d1t_1.t1t_1));
            this.t7_1 = 8;
            continue $sm;
          } else {
            var tmp_1 = this.f1t_1;
            if (tmp_1 instanceof Ping_0) {
              this.t7_1 = 6;
              suspendResult = this.d1t_1.u1t_1.e1u(this.e1t_1.d1u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this.f1t_1;
              if (tmp_2 instanceof BeginSession) {
                this.t7_1 = 5;
                suspendResult = this.d1t_1.u1t_1.c1u(this.e1t_1.b1u_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this.f1t_1;
                if (tmp_3 instanceof EndSession) {
                  this.t7_1 = 4;
                  suspendResult = this.d1t_1.u1t_1.a1u(this.e1t_1.z1t_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this.f1t_1;
                  if (tmp_4 instanceof GetSignedPayload) {
                    this.t7_1 = 3;
                    suspendResult = this.d1t_1.u1t_1.y1t(this.e1t_1.x1t_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_5 = this.f1t_1;
                    if (tmp_5 instanceof GetDigSigAvailability) {
                      this.t7_1 = 2;
                      suspendResult = this.d1t_1.u1t_1.w1t(this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      var tmp_6 = this.f1t_1;
                      if (tmp_6 instanceof StartDigSigEnrollment) {
                        this.t7_1 = 1;
                        suspendResult = this.d1t_1.u1t_1.v1t(this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        var tmp_7 = this;
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
          break;
        case 1:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 2:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 3:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 4:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 5:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 6:
          this.g1t_1 = suspendResult;
          this.t7_1 = 8;
          continue $sm;
        case 7:
          throw this.w7_1;
        case 8:
          return this.g1t_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 7) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function IpcHostRequestHandler(appInfo, commandHandler) {
  IpcBaseRequestHandler.call(this);
  this.t1t_1 = appInfo;
  this.u1t_1 = commandHandler;
}
protoOf(IpcHostRequestHandler).t1s = function (req, $completion) {
  var tmp = new $handleRequestCOROUTINE$0(this, req, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
function delegate_0($this, cmd, $completion) {
  var tmp = new $delegateCOROUTINE$3($this, cmd, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
}
function $handleRequestCOROUTINE$2(_this__u8e3s4, req, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z1u_1 = _this__u8e3s4;
  this.a1v_1 = req;
}
protoOf($handleRequestCOROUTINE$2).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 4;
          this.b1v_1 = this.a1v_1;
          var tmp_0 = this.b1v_1;
          if (tmp_0 instanceof AppCmd) {
            this.t7_1 = 2;
            suspendResult = delegate_0(this.z1u_1, this.a1v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            var tmp_1 = this.b1v_1;
            if (tmp_1 instanceof WebCmd) {
              this.c1v_1 = new Failure(new InvalidRequest('Web command sent to web handler. Make sure the request inherits from the correct class.'));
              this.t7_1 = 3;
              continue $sm;
            } else {
              this.t7_1 = 1;
              suspendResult = protoOf(IpcBaseRequestHandler).t1s.call(this.z1u_1, this.a1v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          }
        case 1:
          this.c1v_1 = suspendResult;
          this.t7_1 = 3;
          continue $sm;
        case 2:
          this.c1v_1 = suspendResult;
          this.t7_1 = 3;
          continue $sm;
        case 3:
          return this.c1v_1;
        case 4:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 4) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function $delegateCOROUTINE$3(_this__u8e3s4, cmd, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n1u_1 = _this__u8e3s4;
  this.o1u_1 = cmd;
}
protoOf($delegateCOROUTINE$3).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 3;
          this.p1u_1 = this.o1u_1;
          var tmp_0 = this.p1u_1;
          if (tmp_0 instanceof Ping) {
            this.t7_1 = 1;
            suspendResult = this.n1u_1.d1v_1.e1u(this.o1u_1.e1v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            var tmp_1 = this;
            noWhenBranchMatchedException();
          }
          break;
        case 1:
          this.q1u_1 = suspendResult;
          this.t7_1 = 2;
          continue $sm;
        case 2:
          return this.q1u_1;
        case 3:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 3) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function IpcClientRequestHandler(commandHandler) {
  IpcBaseRequestHandler.call(this);
  this.d1v_1 = commandHandler;
}
protoOf(IpcClientRequestHandler).t1s = function (req, $completion) {
  var tmp = new $handleRequestCOROUTINE$2(this, req, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
function IpcConnection$request$slambda$slambda($id, resultContinuation) {
  this.n1v_1 = $id;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$request$slambda$slambda).p1v = function (it, $completion) {
  var tmp = this.q1v(it, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$request$slambda$slambda).x8 = function (p1, $completion) {
  return this.p1v((!(p1 == null) ? isInterface(p1, KtMutableMap) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$request$slambda$slambda).l8 = function () {
  this.v7_1;
  do {
    try {
      var tmp = this.t7_1;
      if (tmp === 0) {
        this.u7_1 = 1;
        return this.o1v_1.v1(this.n1v_1);
      } else if (tmp === 1) {
        throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
  } while (true);
};
protoOf(IpcConnection$request$slambda$slambda).q1v = function (it, completion) {
  var i = new IpcConnection$request$slambda$slambda(this.n1v_1, completion);
  i.o1v_1 = it;
  return i;
};
function IpcConnection$request$slambda$slambda_0($id, resultContinuation) {
  var i = new IpcConnection$request$slambda$slambda($id, resultContinuation);
  var l = function l(it, $completion) {
    return i.p1v(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda$slambda($frame, resultContinuation) {
  this.z1v_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda$slambda).b1w = function (it, $completion) {
  var tmp = this.q1v(it, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda$slambda).x8 = function (p1, $completion) {
  return this.b1w((!(p1 == null) ? isInterface(p1, KtMutableMap) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda$slambda).l8 = function () {
  this.v7_1;
  do {
    try {
      var tmp = this.t7_1;
      if (tmp === 0) {
        this.u7_1 = 1;
        var tmp0 = this.a1w_1;
        var tmp1 = this.z1v_1.d1w_1;
        var value = new Success_0(this.z1v_1.f1w_1);
        tmp0.z1(tmp1, value);
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda$slambda).q1v = function (it, completion) {
  var i = new IpcConnection$onReceive$slambda$slambda(this.z1v_1, completion);
  i.a1w_1 = it;
  return i;
};
function IpcConnection$onReceive$slambda$slambda_0($frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda$slambda($frame, resultContinuation);
  var l = function l(it, $completion) {
    return i.b1w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda$slambda_1($frame, resultContinuation) {
  this.p1w_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda$slambda_1).b1w = function (it, $completion) {
  var tmp = this.q1v(it, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda$slambda_1).x8 = function (p1, $completion) {
  return this.b1w((!(p1 == null) ? isInterface(p1, KtMutableMap) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda$slambda_1).l8 = function () {
  this.v7_1;
  do {
    try {
      var tmp = this.t7_1;
      if (tmp === 0) {
        this.u7_1 = 1;
        var tmp0 = this.q1w_1;
        var tmp1 = this.p1w_1.d1w_1;
        var value = new Failure(this.p1w_1.g1w_1);
        tmp0.z1(tmp1, value);
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda$slambda_1).q1v = function (it, completion) {
  var i = new IpcConnection$onReceive$slambda$slambda_1(this.p1w_1, completion);
  i.q1w_1 = it;
  return i;
};
function IpcConnection$onReceive$slambda$slambda_2($frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda$slambda_1($frame, resultContinuation);
  var l = function l(it, $completion) {
    return i.b1w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function executeRequest($this, id, req, $completion) {
  var tmp = new $executeRequestCOROUTINE$5($this, id, req, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
}
function reply($this, to, result) {
  var tmp;
  if (result instanceof Success_0) {
    tmp = new IpcFrame(VOID, to, VOID, result.data);
  } else {
    if (result instanceof Failure) {
      tmp = new IpcFrame(VOID, to, VOID, VOID, result.error);
    } else {
      noWhenBranchMatchedException();
    }
  }
  var frame = tmp;
  $this.n1s_1(frame);
}
function IpcConnection$request$slambda(this$0, $id, resultContinuation) {
  this.k1x_1 = this$0;
  this.l1x_1 = $id;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$request$slambda).o1x = function ($this$withTimeoutOrNull, $completion) {
  var tmp = this.p1x($this$withTimeoutOrNull, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$request$slambda).x8 = function (p1, $completion) {
  return this.o1x((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$request$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 4;
          this.t7_1 = 1;
          continue $sm;
        case 1:
          if (!true) ;
          this.t7_1 = 2;
          suspendResult = this.k1x_1.p1s_1.s1x(IpcConnection$request$slambda$slambda_0(this.l1x_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 2:
          this.n1x_1 = suspendResult;
          var tmp_0 = this.n1x_1;
          var tmp0_safe_receiver = tmp_0 instanceof IpcResult ? tmp_0 : null;
          if (tmp0_safe_receiver == null) null;else {
            return tmp0_safe_receiver;
          }
          this.t7_1 = 3;
          Companion_getInstance_16$1();
          suspendResult = delay(toDuration(100, DurationUnit_MICROSECONDS_getInstance()), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 3:
          this.t7_1 = 1;
          continue $sm;
        case 4:
          throw this.w7_1;
        case 5:
          return null;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 4) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(IpcConnection$request$slambda).p1x = function ($this$withTimeoutOrNull, completion) {
  var i = new IpcConnection$request$slambda(this.k1x_1, this.l1x_1, completion);
  i.m1x_1 = $this$withTimeoutOrNull;
  return i;
};
function IpcConnection$request$slambda_0(this$0, $id, resultContinuation) {
  var i = new IpcConnection$request$slambda(this$0, $id, resultContinuation);
  var l = function l($this$withTimeoutOrNull, $completion) {
    return i.o1x($this$withTimeoutOrNull, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$request$slambda_1($id, resultContinuation) {
  this.b1y_1 = $id;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$request$slambda_1).p1v = function (it, $completion) {
  var tmp = this.q1v(it, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$request$slambda_1).x8 = function (p1, $completion) {
  return this.p1v((!(p1 == null) ? isInterface(p1, KtMutableMap) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$request$slambda_1).l8 = function () {
  this.v7_1;
  do {
    try {
      var tmp = this.t7_1;
      if (tmp === 0) {
        this.u7_1 = 1;
        return this.c1y_1.a2(this.b1y_1);
      } else if (tmp === 1) {
        throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
  } while (true);
};
protoOf(IpcConnection$request$slambda_1).q1v = function (it, completion) {
  var i = new IpcConnection$request$slambda_1(this.b1y_1, completion);
  i.c1y_1 = it;
  return i;
};
function IpcConnection$request$slambda_2($id, resultContinuation) {
  var i = new IpcConnection$request$slambda_1($id, resultContinuation);
  var l = function l(it, $completion) {
    return i.p1v(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda(this$0, $frame, resultContinuation) {
  this.l1y_1 = this$0;
  this.m1y_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda).o1y = function ($this$launch, $completion) {
  var tmp = this.p1x($this$launch, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda).x8 = function (p1, $completion) {
  return this.o1y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = executeRequest(this.l1y_1, this.m1y_1.d1w_1, this.m1y_1.e1w_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda).p1x = function ($this$launch, completion) {
  var i = new IpcConnection$onReceive$slambda(this.l1y_1, this.m1y_1, completion);
  i.n1y_1 = $this$launch;
  return i;
};
function IpcConnection$onReceive$slambda_0(this$0, $frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda(this$0, $frame, resultContinuation);
  var l = function l($this$launch, $completion) {
    return i.o1y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda_1(this$0, $frame, resultContinuation) {
  this.x1y_1 = this$0;
  this.y1y_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda_1).o1y = function ($this$launch, $completion) {
  var tmp = this.p1x($this$launch, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda_1).x8 = function (p1, $completion) {
  return this.o1y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda_1).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.x1y_1.p1s_1.s1x(IpcConnection$onReceive$slambda$slambda_0(this.y1y_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda_1).p1x = function ($this$launch, completion) {
  var i = new IpcConnection$onReceive$slambda_1(this.x1y_1, this.y1y_1, completion);
  i.z1y_1 = $this$launch;
  return i;
};
function IpcConnection$onReceive$slambda_2(this$0, $frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda_1(this$0, $frame, resultContinuation);
  var l = function l($this$launch, $completion) {
    return i.o1y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda_3(this$0, $frame, resultContinuation) {
  this.i1z_1 = this$0;
  this.j1z_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda_3).o1y = function ($this$launch, $completion) {
  var tmp = this.p1x($this$launch, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda_3).x8 = function (p1, $completion) {
  return this.o1y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda_3).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.i1z_1.p1s_1.s1x(IpcConnection$onReceive$slambda$slambda_2(this.j1z_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda_3).p1x = function ($this$launch, completion) {
  var i = new IpcConnection$onReceive$slambda_3(this.i1z_1, this.j1z_1, completion);
  i.k1z_1 = $this$launch;
  return i;
};
function IpcConnection$onReceive$slambda_4(this$0, $frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda_3(this$0, $frame, resultContinuation);
  var l = function l($this$launch, $completion) {
    return i.o1y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$onReceive$slambda_5(this$0, $frame, resultContinuation) {
  this.t1z_1 = this$0;
  this.u1z_1 = $frame;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$onReceive$slambda_5).o1y = function ($this$launch, $completion) {
  var tmp = this.p1x($this$launch, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$onReceive$slambda_5).x8 = function (p1, $completion) {
  return this.o1y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$onReceive$slambda_5).l8 = function () {
  this.v7_1;
  do {
    try {
      var tmp = this.t7_1;
      if (tmp === 0) {
        this.u7_1 = 1;
        reply(this.t1z_1, this.u1z_1.d1w_1, new Failure(new InvalidRequest('Invalid frame: No request, response or error.')));
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
  } while (true);
};
protoOf(IpcConnection$onReceive$slambda_5).p1x = function ($this$launch, completion) {
  var i = new IpcConnection$onReceive$slambda_5(this.t1z_1, this.u1z_1, completion);
  i.v1z_1 = $this$launch;
  return i;
};
function IpcConnection$onReceive$slambda_6(this$0, $frame, resultContinuation) {
  var i = new IpcConnection$onReceive$slambda_5(this$0, $frame, resultContinuation);
  var l = function l($this$launch, $completion) {
    return i.o1y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function IpcConnection$executeRequest$slambda(this$0, $id, $req, resultContinuation) {
  this.e20_1 = this$0;
  this.f20_1 = $id;
  this.g20_1 = $req;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(IpcConnection$executeRequest$slambda).o1y = function ($this$withTimeoutOrNull, $completion) {
  var tmp = this.p1x($this$withTimeoutOrNull, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection$executeRequest$slambda).x8 = function (p1, $completion) {
  return this.o1y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(IpcConnection$executeRequest$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 3;
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.e20_1.o1s_1.t1s(this.g20_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          reply(this.e20_1, this.f20_1, ARGUMENT);
          this.u7_1 = 3;
          this.t7_1 = 4;
          continue $sm;
        case 2:
          this.u7_1 = 3;
          var tmp_0 = this.w7_1;
          if (tmp_0 instanceof Exception) {
            var e = this.w7_1;
            reply(this.e20_1, this.f20_1, new Failure(new HandlerException('Request handler threw: ' + e.toString())));
            this.t7_1 = 4;
            continue $sm;
          } else {
            throw this.w7_1;
          }
        case 3:
          throw this.w7_1;
        case 4:
          this.u7_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.u7_1 === 3) {
        throw e_0;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e_0;
      }
    }
  } while (true);
};
protoOf(IpcConnection$executeRequest$slambda).p1x = function ($this$withTimeoutOrNull, completion) {
  var i = new IpcConnection$executeRequest$slambda(this.e20_1, this.f20_1, this.g20_1, completion);
  i.h20_1 = $this$withTimeoutOrNull;
  return i;
};
function IpcConnection$executeRequest$slambda_0(this$0, $id, $req, resultContinuation) {
  var i = new IpcConnection$executeRequest$slambda(this$0, $id, $req, resultContinuation);
  var l = function l($this$withTimeoutOrNull, $completion) {
    return i.o1y($this$withTimeoutOrNull, $completion);
  };
  l.$arity = 1;
  return l;
}
function $requestCOROUTINE$4(_this__u8e3s4, req, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.q20_1 = _this__u8e3s4;
  this.r20_1 = req;
}
protoOf($requestCOROUTINE$4).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 4;
          var tmp_0 = this;
          tmp_0.s20_1 = this.q20_1.r1s_1;
          this.t20_1 = this.s20_1;
          var tmp_1 = this;
          tmp_1.u20_1 = null;
          this.t7_1 = 1;
          suspendResult = this.t20_1.j1q(this.u20_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var tmp_2 = this;
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var tmp_3;
            try {
              var _unary__edvuaz = this.q20_1.q1s_1;
              this.q20_1.q1s_1 = _unary__edvuaz + 1 | 0;
              tmp$ret$0 = _unary__edvuaz;
              break l$ret$1;
            } catch ($p) {
              var tmp_4;
              var t = $p;
              this.t20_1.u1p(this.u20_1);
              throw t;
            }
          } while (false);
          var tmp_5 = tmp$ret$0;
          this.t20_1.u1p(this.u20_1);
          tmp_2.v20_1 = tmp_5;
          this.q20_1.n1s_1(new IpcFrame(VOID, this.v20_1, this.r20_1));
          this.t7_1 = 2;
          var tmp_6 = new Long(30000, 0);
          suspendResult = withTimeoutOrNull(tmp_6, IpcConnection$request$slambda_0(this.q20_1, this.v20_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 2:
          this.w20_1 = suspendResult;
          this.t7_1 = 3;
          suspendResult = this.q20_1.p1s_1.s1x(IpcConnection$request$slambda_2(this.v20_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 3:
          var tmp0_elvis_lhs = this.w20_1;
          return tmp0_elvis_lhs == null ? new Failure(new Timeout('No reply received within 30000 ms')) : tmp0_elvis_lhs;
        case 4:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 4) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function $executeRequestCOROUTINE$5(_this__u8e3s4, id, req, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z1w_1 = _this__u8e3s4;
  this.a1x_1 = id;
  this.b1x_1 = req;
}
protoOf($executeRequestCOROUTINE$5).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          var tmp_0 = new Long(29000, 0);
          suspendResult = withTimeoutOrNull(tmp_0, IpcConnection$executeRequest$slambda_0(this.z1w_1, this.a1x_1, this.b1x_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var result = suspendResult;
          if (result == null) {
            reply(this.z1w_1, this.a1x_1, new Failure(new HandlerException('Request handling timed out on receiver side - aborted')));
          }
          return Unit_instance;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function IpcConnection(scope, send, requestHandler) {
  this.m1s_1 = scope;
  this.n1s_1 = send;
  this.o1s_1 = requestHandler;
  this.p1s_1 = new MutexedMap();
  this.q1s_1 = 0;
  this.r1s_1 = Mutex();
}
protoOf(IpcConnection).s1s = function (req, $completion) {
  var tmp = new $requestCOROUTINE$4(this, req, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(IpcConnection).x20 = function (frame) {
  if (!(frame.e1w_1 == null)) {
    launch(this.m1s_1, VOID, VOID, IpcConnection$onReceive$slambda_0(this, frame, null));
  } else if (!(frame.f1w_1 == null)) {
    launch(this.m1s_1, VOID, VOID, IpcConnection$onReceive$slambda_2(this, frame, null));
  } else if (!(frame.g1w_1 == null)) {
    launch(this.m1s_1, VOID, VOID, IpcConnection$onReceive$slambda_4(this, frame, null));
  } else {
    launch(this.m1s_1, VOID, VOID, IpcConnection$onReceive$slambda_6(this, frame, null));
  }
};
function Success() {
  Success_instance = this;
  IpcDecodeFrameResult.call(this);
}
protoOf(Success).toString = function () {
  return 'Success';
};
protoOf(Success).hashCode = function () {
  return -923318675;
};
protoOf(Success).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Success)) return false;
  other instanceof Success || THROW_CCE();
  return true;
};
var Success_instance;
function Success_getInstance() {
  if (Success_instance == null) new Success();
  return Success_instance;
}
function Failed(msg, error) {
  error = error === VOID ? null : error;
  IpcDecodeFrameResult.call(this);
  this.msg = msg;
  this.error = error;
}
protoOf(Failed).y20 = function () {
  return this.msg;
};
protoOf(Failed).z20 = function () {
  return this.error;
};
protoOf(Failed).xc = function () {
  return this.msg;
};
protoOf(Failed).yc = function () {
  return this.error;
};
protoOf(Failed).a21 = function (msg, error) {
  return new Failed(msg, error);
};
protoOf(Failed).copy = function (msg, error, $super) {
  msg = msg === VOID ? this.msg : msg;
  error = error === VOID ? this.error : error;
  return this.a21(msg, error);
};
protoOf(Failed).toString = function () {
  return 'Failed(msg=' + this.msg + ', error=' + toString_0(this.error) + ')';
};
protoOf(Failed).hashCode = function () {
  var result = getStringHashCode(this.msg);
  result = imul(result, 31) + (this.error == null ? 0 : hashCode(this.error)) | 0;
  return result;
};
protoOf(Failed).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Failed)) return false;
  var tmp0_other_with_cast = other instanceof Failed ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  if (!equals(this.error, tmp0_other_with_cast.error)) return false;
  return true;
};
function IpcDecodeFrameResult() {}
function IpcErrorException(ipcError) {
  Exception_init_$Init$(this);
  captureStack(this, IpcErrorException);
  this.ipcError = ipcError;
}
protoOf(IpcErrorException).b21 = function () {
  return this.ipcError;
};
protoOf(IpcErrorException).toString = function () {
  return 'IpcErrorException: ' + toString_1(this.ipcError);
};
function IpcHost$onReceive$lambda(this$0, $receiverId) {
  return function (it) {
    this$0.d21_1.h21($receiverId, IpcJson_instance.g21(it));
    return Unit_instance;
  };
}
function IpcHost(scope, txChannel, onConnectRequest) {
  this.c21_1 = scope;
  this.d21_1 = txChannel;
  this.e21_1 = onConnectRequest;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.f21_1 = LinkedHashMap_init_$Create$();
}
protoOf(IpcHost).i21 = function (msg) {
  var tmp;
  try {
    tmp = IpcJson_instance.j21(msg);
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      return new Failed('Failed to parse IPC frame', e);
    } else {
      throw $p;
    }
  }
  var frame = tmp;
  var tmp0_elvis_lhs = frame.c1w_1;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return new Failed('Missing receiver id in IPC frame');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var receiverId = tmp_1;
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = this.f21_1;
  var value = this_0.v1(receiverId);
  var tmp_2;
  if (value == null) {
    // Inline function 'com.verisure.mymobile.myipc.IpcHost.onReceive.<anonymous>' call
    var handler = this.e21_1(receiverId);
    var answer = new IpcConnection(this.c21_1, IpcHost$onReceive$lambda(this, receiverId), handler);
    this_0.z1(receiverId, answer);
    tmp_2 = answer;
  } else {
    tmp_2 = value;
  }
  var receiver = tmp_2;
  try {
    receiver.x20(frame);
  } catch ($p) {
    if ($p instanceof Error) {
      var e_0 = $p;
      return new Failed('Failed to handle IPC frame', e_0);
    } else {
      throw $p;
    }
  }
  return Success_getInstance();
};
protoOf(IpcHost).k21 = function () {
  var tmp0_safe_receiver = firstOrNull(this.f21_1.x1());
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.verisure.mymobile.myipc.IpcHost.firstConnectionOrNull.<anonymous>' call
    tmp = new DefaultIpcHostConnection(tmp0_safe_receiver);
  }
  return tmp;
};
function DefaultIpcHostConnection(connection) {
  this.l21_1 = connection;
  this.m21_1 = new DefaultIpcHostCommands(this.l21_1);
}
protoOf(DefaultIpcHostConnection).n21 = function () {
  return this.m21_1;
};
function IpcTxToWebChannel() {}
function Companion() {
  Companion_instance = this;
  var tmp = this;
  var tmp_0 = getKClass(IpcRequest);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [getKClass(Ping), getKClass(IpcDebugErrorRequest), getKClass(UnknownRequest), getKClass(BeginSession), getKClass(Connect), getKClass(EndSession), getKClass(GetDigSigAvailability), getKClass(GetSignedPayload), getKClass(Ping_0), getKClass(StartDigSigEnrollment)];
  var tmp_2 = $serializer_getInstance_17();
  var tmp_3 = $serializer_getInstance_18();
  var tmp_4 = UnknownRequest_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  var tmp_5 = ObjectSerializer_init_$Create$('ipc.req.UnknownRequest', tmp_4, tmp$ret$5);
  var tmp_6 = $serializer_getInstance_19();
  var tmp_7 = $serializer_getInstance_20();
  var tmp_8 = $serializer_getInstance_21();
  var tmp_9 = GetDigSigAvailability_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  var tmp_10 = ObjectSerializer_init_$Create$('ipc.req.WebCmd.GetDigSigAvailability', tmp_9, tmp$ret$8);
  var tmp_11 = $serializer_getInstance_23();
  var tmp_12 = $serializer_getInstance_22();
  var tmp_13 = StartDigSigEnrollment_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_14 = [tmp_2, tmp_3, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_11, tmp_12, ObjectSerializer_init_$Create$('ipc.req.WebCmd.StartDigSigEnrollment', tmp_13, tmp$ret$11)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$17 = [];
  var tmp_15 = SealedClassSerializer_init_$Create$('ipc.req.IpcRequest', tmp_0, tmp_1, tmp_14, tmp$ret$17);
  var tmp_16 = getKClass(IpcReply_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_17 = [getKClass(IpcConnectReply), getKClass(IpcDigSigAvailabilityReply), getKClass(IpcDigSigSignPayloadReply), getKClass(IpcPingReply), getKClass(IpcVoid_0)];
  var tmp_18 = $serializer_getInstance_13();
  var tmp_19 = $serializer_getInstance_14();
  var tmp_20 = $serializer_getInstance_15();
  var tmp_21 = $serializer_getInstance_16();
  var tmp_22 = IpcVoid_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$23 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_23 = [tmp_18, tmp_19, tmp_20, tmp_21, ObjectSerializer_init_$Create$('ipc.reply.IpcVoid', tmp_22, tmp$ret$23)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$29 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.p21_1 = [null, null, tmp_15, SealedClassSerializer_init_$Create$('ipc.reply.IpcReply', tmp_16, tmp_17, tmp_23, tmp$ret$29), Companion_getInstance_15().m15()];
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null) new Companion();
  return Companion_instance;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.verisure.mymobile.myipc.protocol.IpcFrame', this, 5);
  tmp0_serialDesc.mt('rx', true);
  tmp0_serialDesc.mt('id', false);
  tmp0_serialDesc.mt('req', true);
  tmp0_serialDesc.mt('resp', true);
  tmp0_serialDesc.mt('error', true);
  this.q21_1 = tmp0_serialDesc;
}
protoOf($serializer).r21 = function (encoder, value) {
  var tmp0_desc = this.q21_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  var tmp2_cached = Companion_getInstance_0().p21_1;
  if (tmp1_output.bo(tmp0_desc, 0) ? true : !(value.c1w_1 == null)) {
    tmp1_output.xn(tmp0_desc, 0, StringSerializer_getInstance(), value.c1w_1);
  }
  tmp1_output.on(tmp0_desc, 1, value.d1w_1);
  if (tmp1_output.bo(tmp0_desc, 2) ? true : !(value.e1w_1 == null)) {
    tmp1_output.xn(tmp0_desc, 2, tmp2_cached[2], value.e1w_1);
  }
  if (tmp1_output.bo(tmp0_desc, 3) ? true : !(value.f1w_1 == null)) {
    tmp1_output.xn(tmp0_desc, 3, tmp2_cached[3], value.f1w_1);
  }
  if (tmp1_output.bo(tmp0_desc, 4) ? true : !(value.g1w_1 == null)) {
    tmp1_output.xn(tmp0_desc, 4, tmp2_cached[4], value.g1w_1);
  }
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer).bj = function (encoder, value) {
  return this.r21(encoder, value instanceof IpcFrame ? value : THROW_CCE());
};
protoOf($serializer).cj = function (decoder) {
  var tmp0_desc = this.q21_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = 0;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.fm(tmp0_desc);
  var tmp10_cached = Companion_getInstance_0().p21_1;
  if (tmp9_input.vm()) {
    tmp4_local0 = tmp9_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.km(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.tm(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.tm(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.tm(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else while (tmp1_flag) {
    tmp2_index = tmp9_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp9_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp9_input.km(tmp0_desc, 1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      case 2:
        tmp6_local2 = tmp9_input.tm(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
        tmp3_bitMask0 = tmp3_bitMask0 | 4;
        break;
      case 3:
        tmp7_local3 = tmp9_input.tm(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
        tmp3_bitMask0 = tmp3_bitMask0 | 8;
        break;
      case 4:
        tmp8_local4 = tmp9_input.tm(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
        tmp3_bitMask0 = tmp3_bitMask0 | 16;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp9_input.gm(tmp0_desc);
  return IpcFrame_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer).aj = function () {
  return this.q21_1;
};
protoOf($serializer).ot = function () {
  var tmp0_cached = Companion_getInstance_0().p21_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4])];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null) new $serializer();
  return $serializer_instance;
}
function IpcFrame_init_$Init$(seen0, rx, id, req, resp, error, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance().q21_1);
  }
  if (0 === (seen0 & 1)) $this.c1w_1 = null;else $this.c1w_1 = rx;
  $this.d1w_1 = id;
  if (0 === (seen0 & 4)) $this.e1w_1 = null;else $this.e1w_1 = req;
  if (0 === (seen0 & 8)) $this.f1w_1 = null;else $this.f1w_1 = resp;
  if (0 === (seen0 & 16)) $this.g1w_1 = null;else $this.g1w_1 = error;
  return $this;
}
function IpcFrame_init_$Create$(seen0, rx, id, req, resp, error, serializationConstructorMarker) {
  return IpcFrame_init_$Init$(seen0, rx, id, req, resp, error, serializationConstructorMarker, objectCreate(protoOf(IpcFrame)));
}
function IpcFrame(rx, id, req, resp, error) {
  Companion_getInstance_0();
  rx = rx === VOID ? null : rx;
  req = req === VOID ? null : req;
  resp = resp === VOID ? null : resp;
  error = error === VOID ? null : error;
  this.c1w_1 = rx;
  this.d1w_1 = id;
  this.e1w_1 = req;
  this.f1w_1 = resp;
  this.g1w_1 = error;
}
protoOf(IpcFrame).s21 = function (rx, id, req, resp, error) {
  return new IpcFrame(rx, id, req, resp, error);
};
protoOf(IpcFrame).t21 = function (rx, id, req, resp, error, $super) {
  rx = rx === VOID ? this.c1w_1 : rx;
  id = id === VOID ? this.d1w_1 : id;
  req = req === VOID ? this.e1w_1 : req;
  resp = resp === VOID ? this.f1w_1 : resp;
  error = error === VOID ? this.g1w_1 : error;
  return $super === VOID ? this.s21(rx, id, req, resp, error) : $super.s21.call(this, rx, id, req, resp, error);
};
protoOf(IpcFrame).toString = function () {
  return 'IpcFrame(rx=' + this.c1w_1 + ', id=' + this.d1w_1 + ', req=' + toString_0(this.e1w_1) + ', resp=' + toString_0(this.f1w_1) + ', error=' + toString_0(this.g1w_1) + ')';
};
protoOf(IpcFrame).hashCode = function () {
  var result = this.c1w_1 == null ? 0 : getStringHashCode(this.c1w_1);
  result = imul(result, 31) + this.d1w_1 | 0;
  result = imul(result, 31) + (this.e1w_1 == null ? 0 : hashCode(this.e1w_1)) | 0;
  result = imul(result, 31) + (this.f1w_1 == null ? 0 : hashCode(this.f1w_1)) | 0;
  result = imul(result, 31) + (this.g1w_1 == null ? 0 : hashCode(this.g1w_1)) | 0;
  return result;
};
protoOf(IpcFrame).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcFrame)) return false;
  var tmp0_other_with_cast = other instanceof IpcFrame ? other : THROW_CCE();
  if (!(this.c1w_1 == tmp0_other_with_cast.c1w_1)) return false;
  if (!(this.d1w_1 === tmp0_other_with_cast.d1w_1)) return false;
  if (!equals(this.e1w_1, tmp0_other_with_cast.e1w_1)) return false;
  if (!equals(this.f1w_1, tmp0_other_with_cast.f1w_1)) return false;
  if (!equals(this.g1w_1, tmp0_other_with_cast.g1w_1)) return false;
  return true;
};
function get_json() {
  _init_properties_IpcJson_kt__kdacc2();
  return json;
}
var json;
function IpcJson() {}
protoOf(IpcJson).g21 = function (frame) {
  // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
  var this_0 = get_json();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.um();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(getKClass(IpcFrame), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  return this_0.a13(tmp$ret$1, frame);
};
protoOf(IpcJson).j21 = function (frame) {
  // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
  var this_0 = get_json();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.um();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer(this_1, createKType(getKClass(IpcFrame), arrayOf([]), false));
  var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  return this_0.b13(tmp$ret$1, frame);
};
var IpcJson_instance;
function MapToUnknownRequestSerializer() {
  MapToUnknownRequestSerializer_instance = this;
  JsonContentPolymorphicSerializer.call(this, getKClass(IpcRequest));
}
protoOf(MapToUnknownRequestSerializer).f15 = function (element) {
  return UnknownRequest_getInstance().m15();
};
var MapToUnknownRequestSerializer_instance;
function MapToUnknownRequestSerializer_getInstance() {
  if (MapToUnknownRequestSerializer_instance == null) new MapToUnknownRequestSerializer();
  return MapToUnknownRequestSerializer_instance;
}
function MapToUnknownErrorSerializer() {
  MapToUnknownErrorSerializer_instance = this;
  JsonContentPolymorphicSerializer.call(this, getKClass(IpcError));
}
protoOf(MapToUnknownErrorSerializer).f15 = function (element) {
  return UnknownResponseError_getInstance().m15();
};
var MapToUnknownErrorSerializer_instance;
function MapToUnknownErrorSerializer_getInstance() {
  if (MapToUnknownErrorSerializer_instance == null) new MapToUnknownErrorSerializer();
  return MapToUnknownErrorSerializer_instance;
}
function MapToUnknownEndResultSerializer() {
  MapToUnknownEndResultSerializer_instance = this;
  JsonContentPolymorphicSerializer.call(this, getKClass(EndResult));
}
protoOf(MapToUnknownEndResultSerializer).f15 = function (element) {
  return Unknown_getInstance().m15();
};
var MapToUnknownEndResultSerializer_instance;
function MapToUnknownEndResultSerializer_getInstance() {
  if (MapToUnknownEndResultSerializer_instance == null) new MapToUnknownEndResultSerializer();
  return MapToUnknownEndResultSerializer_instance;
}
function json$lambda($this$Json) {
  _init_properties_IpcJson_kt__kdacc2();
  $this$Json.u13_1 = true;
  var tmp = $this$Json;
  // Inline function 'kotlinx.serialization.modules.SerializersModule' call
  var builder = new SerializersModuleBuilder();
  // Inline function 'com.verisure.mymobile.myipc.protocol.json.<anonymous>.<anonymous>' call
  var tmp_0 = getKClass(IpcRequest);
  builder.h12(tmp_0, json$lambda$lambda);
  var tmp_1 = getKClass(IpcError);
  builder.h12(tmp_1, json$lambda$lambda_0);
  var tmp_2 = getKClass(EndResult);
  builder.h12(tmp_2, json$lambda$lambda_1);
  tmp.j14_1 = builder.vr();
  return Unit_instance;
}
function json$lambda$lambda(it) {
  _init_properties_IpcJson_kt__kdacc2();
  return MapToUnknownRequestSerializer_getInstance();
}
function json$lambda$lambda_0(it) {
  _init_properties_IpcJson_kt__kdacc2();
  return MapToUnknownErrorSerializer_getInstance();
}
function json$lambda$lambda_1(it) {
  _init_properties_IpcJson_kt__kdacc2();
  return MapToUnknownEndResultSerializer_getInstance();
}
var properties_initialized_IpcJson_kt_6onsa4;
function _init_properties_IpcJson_kt__kdacc2() {
  if (!properties_initialized_IpcJson_kt_6onsa4) {
    properties_initialized_IpcJson_kt_6onsa4 = true;
    json = Json_0(VOID, json$lambda);
  }
}
function $serializer_init_$Init$(typeSerial0, $this) {
  $serializer_0.call($this);
  $this.e22_1 = typeSerial0;
  return $this;
}
function $serializer_init_$Create$(typeSerial0) {
  return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_0)));
}
function Companion_0() {
  Companion_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.verisure.mymobile.myipc.protocol.IpcResult.Success', null, 1);
  tmp0_serialDesc.mt('data', false);
  this.f22_1 = tmp0_serialDesc;
}
protoOf(Companion_0).g22 = function (typeSerial0) {
  return $serializer_init_$Create$(typeSerial0);
};
protoOf(Companion_0).bu = function (typeParamsSerializers) {
  return this.g22(typeParamsSerializers[0]);
};
protoOf(Companion_0).h22 = function () {
  return this.f22_1;
};
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 == null) new Companion_0();
  return Companion_instance_0;
}
function $serializer_0() {
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.verisure.mymobile.myipc.protocol.IpcResult.Success', this, 1);
  tmp0_serialDesc.mt('data', false);
  this.d22_1 = tmp0_serialDesc;
}
protoOf($serializer_0).i22 = function (encoder, value) {
  var tmp0_desc = this.d22_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.vn(tmp0_desc, 0, this.e22_1, value.data);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_0).bj = function (encoder, value) {
  return this.i22(encoder, value instanceof Success_0 ? value : THROW_CCE());
};
protoOf($serializer_0).cj = function (decoder) {
  var tmp0_desc = this.d22_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, this.e22_1, tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, this.e22_1, tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Success_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).aj = function () {
  return this.d22_1;
};
protoOf($serializer_0).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.e22_1];
};
protoOf($serializer_0).pt = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [this.e22_1];
};
function Success_init_$Init$(seen0, data, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, Companion_getInstance_1().f22_1);
  }
  $this.data = data;
  return $this;
}
function Success_init_$Create$(seen0, data, serializationConstructorMarker) {
  return Success_init_$Init$(seen0, data, serializationConstructorMarker, objectCreate(protoOf(Success_0)));
}
function Companion_1() {
  Companion_instance_1 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.j22_1 = [Companion_getInstance_15().m15()];
}
protoOf(Companion_1).m15 = function () {
  return $serializer_getInstance_0();
};
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 == null) new Companion_1();
  return Companion_instance_1;
}
function $serializer_1() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.verisure.mymobile.myipc.protocol.IpcResult.Failure', this, 1);
  tmp0_serialDesc.mt('error', false);
  this.k22_1 = tmp0_serialDesc;
}
protoOf($serializer_1).l22 = function (encoder, value) {
  var tmp0_desc = this.k22_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  var tmp2_cached = Companion_getInstance_2().j22_1;
  tmp1_output.vn(tmp0_desc, 0, tmp2_cached[0], value.error);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_1).bj = function (encoder, value) {
  return this.l22(encoder, value instanceof Failure ? value : THROW_CCE());
};
protoOf($serializer_1).cj = function (decoder) {
  var tmp0_desc = this.k22_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  var tmp6_cached = Companion_getInstance_2().j22_1;
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Failure_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).aj = function () {
  return this.k22_1;
};
protoOf($serializer_1).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_2().j22_1[0]];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null) new $serializer_1();
  return $serializer_instance_0;
}
function Failure_init_$Init$(seen0, error, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().k22_1);
  }
  $this.error = error;
  return $this;
}
function Failure_init_$Create$(seen0, error, serializationConstructorMarker) {
  return Failure_init_$Init$(seen0, error, serializationConstructorMarker, objectCreate(protoOf(Failure)));
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.m22_1.s1();
}
function IpcResult$Companion$_anonymous__ep6ba() {
  var tmp = getKClass(IpcResult);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Failure), getKClass(Success_0)];
  var tmp_1 = $serializer_getInstance_0();
  var tmp_2 = getKClass(IpcReply_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_3 = [tmp_1, $serializer_init_$Create$(PolymorphicSerializer_init_$Create$(tmp_2, tmp$ret$5))];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  return SealedClassSerializer_init_$Create$('com.verisure.mymobile.myipc.protocol.IpcResult', tmp, tmp_0, tmp_3, tmp$ret$11);
}
function Success_0(data) {
  Companion_getInstance_1();
  IpcResult.call(this);
  this.data = data;
}
protoOf(Success_0).n22 = function () {
  return this.data;
};
protoOf(Success_0).xc = function () {
  return this.data;
};
protoOf(Success_0).o22 = function (data) {
  return new Success_0(data);
};
protoOf(Success_0).copy = function (data, $super) {
  data = data === VOID ? this.data : data;
  return this.o22(data);
};
protoOf(Success_0).toString = function () {
  return 'Success(data=' + toString_1(this.data) + ')';
};
protoOf(Success_0).hashCode = function () {
  return hashCode(this.data);
};
protoOf(Success_0).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Success_0)) return false;
  var tmp0_other_with_cast = other instanceof Success_0 ? other : THROW_CCE();
  if (!equals(this.data, tmp0_other_with_cast.data)) return false;
  return true;
};
function Failure(error) {
  Companion_getInstance_2();
  IpcResult.call(this);
  this.error = error;
}
protoOf(Failure).z20 = function () {
  return this.error;
};
protoOf(Failure).xc = function () {
  return this.error;
};
protoOf(Failure).p22 = function (error) {
  return new Failure(error);
};
protoOf(Failure).copy = function (error, $super) {
  error = error === VOID ? this.error : error;
  return this.p22(error);
};
protoOf(Failure).toString = function () {
  return 'Failure(error=' + toString_1(this.error) + ')';
};
protoOf(Failure).hashCode = function () {
  return hashCode(this.error);
};
protoOf(Failure).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Failure)) return false;
  var tmp0_other_with_cast = other instanceof Failure ? other : THROW_CCE();
  if (!equals(this.error, tmp0_other_with_cast.error)) return false;
  return true;
};
function Companion_2() {
  Companion_instance_2 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.m22_1 = lazy(tmp_0, IpcResult$Companion$_anonymous__ep6ba);
}
protoOf(Companion_2).g22 = function (typeSerial0) {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_2).bu = function (typeParamsSerializers) {
  return this.g22(typeParamsSerializers[0]);
};
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 == null) new Companion_2();
  return Companion_instance_2;
}
function IpcResult() {
  Companion_getInstance_3();
}
protoOf(IpcResult).orThrow = function () {
  var tmp;
  if (this instanceof Success_0) {
    tmp = this.data;
  } else {
    if (this instanceof Failure) {
      throw new IpcErrorException(this.error);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
protoOf(IpcResult).fold = function (onSuccess, onFailure) {
  var tmp;
  if (this instanceof Success_0) {
    tmp = onSuccess(this.data);
  } else {
    if (this instanceof Failure) {
      tmp = onFailure(new IpcErrorException(this.error));
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
function $useCOROUTINE$6(_this__u8e3s4, block, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y22_1 = _this__u8e3s4;
  this.z22_1 = block;
}
protoOf($useCOROUTINE$6).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 6;
          var tmp_0 = this;
          tmp_0.a23_1 = this.y22_1.r1x_1;
          this.b23_1 = this.a23_1;
          var tmp_1 = this;
          tmp_1.c23_1 = null;
          this.t7_1 = 1;
          suspendResult = this.b23_1.j1q(this.c23_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          this.d23_1 = Unit_instance;
          this.t7_1 = 2;
          continue $sm;
        case 2:
          this.u7_1 = 5;
          this.t7_1 = 3;
          suspendResult = this.z22_1(this.y22_1.q1x_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 3:
          this.d23_1 = suspendResult;
          this.u7_1 = 6;
          this.t7_1 = 4;
          continue $sm;
        case 4:
          var tmp_2 = this.d23_1;
          this.u7_1 = 6;
          this.b23_1.u1p(this.c23_1);
          return tmp_2;
        case 5:
          this.u7_1 = 6;
          var t = this.w7_1;
          this.b23_1.u1p(this.c23_1);
          throw t;
        case 6:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 6) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
function MutexedMap() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.q1x_1 = LinkedHashMap_init_$Create$();
  this.r1x_1 = Mutex();
}
protoOf(MutexedMap).s1x = function (block, $completion) {
  var tmp = new $useCOROUTINE$6(this, block, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
function Companion_3() {}
function $serializer_2() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.data.ConnectArgs', this, 1);
  tmp0_serialDesc.mt('ipcVersion', false);
  this.e23_1 = tmp0_serialDesc;
}
protoOf($serializer_2).f23 = function (encoder, value) {
  var tmp0_desc = this.e23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.on(tmp0_desc, 0, value.g23_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_2).bj = function (encoder, value) {
  return this.f23(encoder, value instanceof ConnectArgs ? value : THROW_CCE());
};
protoOf($serializer_2).cj = function (decoder) {
  var tmp0_desc = this.e23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.km(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.km(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return ConnectArgs_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_2).aj = function () {
  return this.e23_1;
};
protoOf($serializer_2).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance()];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null) new $serializer_2();
  return $serializer_instance_1;
}
function ConnectArgs_init_$Init$(seen0, ipcVersion, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().e23_1);
  }
  $this.g23_1 = ipcVersion;
  return $this;
}
function ConnectArgs_init_$Create$(seen0, ipcVersion, serializationConstructorMarker) {
  return ConnectArgs_init_$Init$(seen0, ipcVersion, serializationConstructorMarker, objectCreate(protoOf(ConnectArgs)));
}
function ConnectArgs(ipcVersion) {
  this.g23_1 = ipcVersion;
}
protoOf(ConnectArgs).toString = function () {
  return 'ConnectArgs(ipcVersion=' + this.g23_1 + ')';
};
protoOf(ConnectArgs).hashCode = function () {
  return this.g23_1;
};
protoOf(ConnectArgs).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof ConnectArgs)) return false;
  var tmp0_other_with_cast = other instanceof ConnectArgs ? other : THROW_CCE();
  if (!(this.g23_1 === tmp0_other_with_cast.g23_1)) return false;
  return true;
};
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.h23_1.s1();
}
function EndResult$GoBack$_anonymous__rini0s() {
  var tmp = GoBack_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.data.EndResult.GoBack', tmp, tmp$ret$2);
}
function Companion_4() {}
protoOf(Companion_4).m15 = function () {
  return $serializer_getInstance_2();
};
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
function $serializer_3() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.data.EndResult.GoHome', this, 1);
  tmp0_serialDesc.mt('giid', false);
  this.i23_1 = tmp0_serialDesc;
}
protoOf($serializer_3).j23 = function (encoder, value) {
  var tmp0_desc = this.i23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.xn(tmp0_desc, 0, StringSerializer_getInstance(), value.giid);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_3).bj = function (encoder, value) {
  return this.j23(encoder, value instanceof GoHome ? value : THROW_CCE());
};
protoOf($serializer_3).cj = function (decoder) {
  var tmp0_desc = this.i23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.tm(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return GoHome_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_3).aj = function () {
  return this.i23_1;
};
protoOf($serializer_3).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null) new $serializer_3();
  return $serializer_instance_2;
}
function GoHome_init_$Init$(seen0, giid, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_2().i23_1);
  }
  $this.giid = giid;
  return $this;
}
function GoHome_init_$Create$(seen0, giid, serializationConstructorMarker) {
  return GoHome_init_$Init$(seen0, giid, serializationConstructorMarker, objectCreate(protoOf(GoHome)));
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.c22_1.s1();
}
function EndResult$Unknown$_anonymous__u84xx5() {
  var tmp = Unknown_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.data.EndResult.Unknown', tmp, tmp$ret$2);
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.k23_1.s1();
}
function EndResult$Companion$_anonymous__ciy4mv() {
  var tmp = getKClass(EndResult);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(GoBack), getKClass(GoHome), getKClass(Unknown)];
  var tmp_1 = GoBack_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  var tmp_2 = ObjectSerializer_init_$Create$('ipc.data.EndResult.GoBack', tmp_1, tmp$ret$5);
  var tmp_3 = $serializer_getInstance_2();
  var tmp_4 = Unknown_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_5 = [tmp_2, tmp_3, ObjectSerializer_init_$Create$('ipc.data.EndResult.Unknown', tmp_4, tmp$ret$8)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = [];
  return SealedClassSerializer_init_$Create$('ipc.data.EndResult', tmp, tmp_0, tmp_5, tmp$ret$14);
}
function GoBack() {
  GoBack_instance = this;
  EndResult.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.h23_1 = lazy(tmp_0, EndResult$GoBack$_anonymous__rini0s);
}
protoOf(GoBack).m15 = function () {
  return _get_$cachedSerializer__te6jhj_0(this);
};
protoOf(GoBack).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(GoBack).toString = function () {
  return 'GoBack';
};
protoOf(GoBack).hashCode = function () {
  return 1795619191;
};
protoOf(GoBack).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof GoBack)) return false;
  other instanceof GoBack || THROW_CCE();
  return true;
};
var GoBack_instance;
function GoBack_getInstance() {
  if (GoBack_instance == null) new GoBack();
  return GoBack_instance;
}
function GoHome(giid) {
  EndResult.call(this);
  this.giid = giid;
}
protoOf(GoHome).l23 = function () {
  return this.giid;
};
protoOf(GoHome).xc = function () {
  return this.giid;
};
protoOf(GoHome).m23 = function (giid) {
  return new GoHome(giid);
};
protoOf(GoHome).copy = function (giid, $super) {
  giid = giid === VOID ? this.giid : giid;
  return this.m23(giid);
};
protoOf(GoHome).toString = function () {
  return 'GoHome(giid=' + this.giid + ')';
};
protoOf(GoHome).hashCode = function () {
  return this.giid == null ? 0 : getStringHashCode(this.giid);
};
protoOf(GoHome).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof GoHome)) return false;
  var tmp0_other_with_cast = other instanceof GoHome ? other : THROW_CCE();
  if (!(this.giid == tmp0_other_with_cast.giid)) return false;
  return true;
};
function Unknown() {
  Unknown_instance = this;
  EndResult.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.c22_1 = lazy(tmp_0, EndResult$Unknown$_anonymous__u84xx5);
}
protoOf(Unknown).m15 = function () {
  return _get_$cachedSerializer__te6jhj_1(this);
};
protoOf(Unknown).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(Unknown).toString = function () {
  return 'Unknown';
};
protoOf(Unknown).hashCode = function () {
  return -620595774;
};
protoOf(Unknown).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Unknown)) return false;
  other instanceof Unknown || THROW_CCE();
  return true;
};
var Unknown_instance;
function Unknown_getInstance() {
  if (Unknown_instance == null) new Unknown();
  return Unknown_instance;
}
function Companion_5() {
  Companion_instance_5 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.k23_1 = lazy(tmp_0, EndResult$Companion$_anonymous__ciy4mv);
}
protoOf(Companion_5).m15 = function () {
  return _get_$cachedSerializer__te6jhj_2(this);
};
protoOf(Companion_5).bu = function (typeParamsSerializers) {
  return this.m15();
};
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 == null) new Companion_5();
  return Companion_instance_5;
}
function EndResult() {
  Companion_getInstance_6();
}
function Companion_6() {}
protoOf(Companion_6).m15 = function () {
  return $serializer_getInstance_3();
};
var Companion_instance_6;
function Companion_getInstance_7() {
  return Companion_instance_6;
}
function $serializer_4() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.data.SignPayloadData', this, 1);
  tmp0_serialDesc.mt('action', false);
  this.n23_1 = tmp0_serialDesc;
}
protoOf($serializer_4).o23 = function (encoder, value) {
  var tmp0_desc = this.n23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.action);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_4).bj = function (encoder, value) {
  return this.o23(encoder, value instanceof SignPayloadData ? value : THROW_CCE());
};
protoOf($serializer_4).cj = function (decoder) {
  var tmp0_desc = this.n23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return SignPayloadData_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_4).aj = function () {
  return this.n23_1;
};
protoOf($serializer_4).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null) new $serializer_4();
  return $serializer_instance_3;
}
function SignPayloadData_init_$Init$(seen0, action, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_3().n23_1);
  }
  $this.action = action;
  return $this;
}
function SignPayloadData_init_$Create$(seen0, action, serializationConstructorMarker) {
  return SignPayloadData_init_$Init$(seen0, action, serializationConstructorMarker, objectCreate(protoOf(SignPayloadData)));
}
function SignPayloadData(action) {
  this.action = action;
}
protoOf(SignPayloadData).p23 = function () {
  return this.action;
};
protoOf(SignPayloadData).xc = function () {
  return this.action;
};
protoOf(SignPayloadData).q23 = function (action) {
  return new SignPayloadData(action);
};
protoOf(SignPayloadData).copy = function (action, $super) {
  action = action === VOID ? this.action : action;
  return this.q23(action);
};
protoOf(SignPayloadData).toString = function () {
  return 'SignPayloadData(action=' + this.action + ')';
};
protoOf(SignPayloadData).hashCode = function () {
  return getStringHashCode(this.action);
};
protoOf(SignPayloadData).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof SignPayloadData)) return false;
  var tmp0_other_with_cast = other instanceof SignPayloadData ? other : THROW_CCE();
  if (!(this.action === tmp0_other_with_cast.action)) return false;
  return true;
};
function Companion_7() {}
protoOf(Companion_7).m15 = function () {
  return $serializer_getInstance_4();
};
var Companion_instance_7;
function Companion_getInstance_8() {
  return Companion_instance_7;
}
function $serializer_5() {
  $serializer_instance_4 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.error.IpcError.Generic', this, 1);
  tmp0_serialDesc.mt('message', false);
  this.r23_1 = tmp0_serialDesc;
}
protoOf($serializer_5).s23 = function (encoder, value) {
  var tmp0_desc = this.r23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.message);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_5).bj = function (encoder, value) {
  return this.s23(encoder, value instanceof Generic ? value : THROW_CCE());
};
protoOf($serializer_5).cj = function (decoder) {
  var tmp0_desc = this.r23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Generic_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_5).aj = function () {
  return this.r23_1;
};
protoOf($serializer_5).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 == null) new $serializer_5();
  return $serializer_instance_4;
}
function Generic_init_$Init$(seen0, message, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_4().r23_1);
  }
  $this.message = message;
  return $this;
}
function Generic_init_$Create$(seen0, message, serializationConstructorMarker) {
  return Generic_init_$Init$(seen0, message, serializationConstructorMarker, objectCreate(protoOf(Generic)));
}
function Companion_8() {}
protoOf(Companion_8).m15 = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_8;
function Companion_getInstance_9() {
  return Companion_instance_8;
}
function $serializer_6() {
  $serializer_instance_5 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.error.IpcError.Interop.InvalidRequest', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.t23_1 = tmp0_serialDesc;
}
protoOf($serializer_6).u23 = function (encoder, value) {
  var tmp0_desc = this.t23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.msg);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_6).bj = function (encoder, value) {
  return this.u23(encoder, value instanceof InvalidRequest ? value : THROW_CCE());
};
protoOf($serializer_6).cj = function (decoder) {
  var tmp0_desc = this.t23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return InvalidRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_6).aj = function () {
  return this.t23_1;
};
protoOf($serializer_6).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 == null) new $serializer_6();
  return $serializer_instance_5;
}
function InvalidRequest_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_5().t23_1);
  }
  $this.msg = msg;
  return $this;
}
function InvalidRequest_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return InvalidRequest_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(InvalidRequest)));
}
function Companion_9() {}
protoOf(Companion_9).m15 = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_9;
function Companion_getInstance_10() {
  return Companion_instance_9;
}
function $serializer_7() {
  $serializer_instance_6 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.error.IpcError.Interop.Timeout', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.v23_1 = tmp0_serialDesc;
}
protoOf($serializer_7).w23 = function (encoder, value) {
  var tmp0_desc = this.v23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.msg);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_7).bj = function (encoder, value) {
  return this.w23(encoder, value instanceof Timeout ? value : THROW_CCE());
};
protoOf($serializer_7).cj = function (decoder) {
  var tmp0_desc = this.v23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Timeout_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_7).aj = function () {
  return this.v23_1;
};
protoOf($serializer_7).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 == null) new $serializer_7();
  return $serializer_instance_6;
}
function Timeout_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_6().v23_1);
  }
  $this.msg = msg;
  return $this;
}
function Timeout_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return Timeout_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(Timeout)));
}
function Companion_10() {}
protoOf(Companion_10).m15 = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_10;
function Companion_getInstance_11() {
  return Companion_instance_10;
}
function $serializer_8() {
  $serializer_instance_7 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.error.IpcError.Interop.HandlerException', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.x23_1 = tmp0_serialDesc;
}
protoOf($serializer_8).y23 = function (encoder, value) {
  var tmp0_desc = this.x23_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.msg);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_8).bj = function (encoder, value) {
  return this.y23(encoder, value instanceof HandlerException ? value : THROW_CCE());
};
protoOf($serializer_8).cj = function (decoder) {
  var tmp0_desc = this.x23_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return HandlerException_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_8).aj = function () {
  return this.x23_1;
};
protoOf($serializer_8).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 == null) new $serializer_8();
  return $serializer_instance_7;
}
function HandlerException_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_7().x23_1);
  }
  $this.msg = msg;
  return $this;
}
function HandlerException_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return HandlerException_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(HandlerException)));
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.z23_1.s1();
}
function IpcError$Interop$Unsupported$_anonymous__gw5cip() {
  var tmp = Unsupported_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.error.IpcError.Interop.Unsupported', tmp, tmp$ret$2);
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.z21_1.s1();
}
function IpcError$Interop$UnknownResponseError$_anonymous__i8uymz() {
  var tmp = UnknownResponseError_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.error.IpcError.Interop.UnknownResponseError', tmp, tmp$ret$2);
}
function _get_$cachedSerializer__te6jhj_5($this) {
  return $this.a24_1.s1();
}
function IpcError$Interop$Companion$_anonymous__8tw4ja() {
  var tmp = getKClass(Interop);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(HandlerException), getKClass(InvalidRequest), getKClass(Timeout), getKClass(UnknownResponseError)];
  var tmp_1 = $serializer_getInstance_7();
  var tmp_2 = $serializer_getInstance_5();
  var tmp_3 = $serializer_getInstance_6();
  var tmp_4 = UnknownResponseError_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_5 = [tmp_1, tmp_2, tmp_3, ObjectSerializer_init_$Create$('ipc.error.IpcError.Interop.UnknownResponseError', tmp_4, tmp$ret$5)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  return SealedClassSerializer_init_$Create$('ipc.error.IpcError.Interop', tmp, tmp_0, tmp_5, tmp$ret$11);
}
function InvalidRequest(msg) {
  Interop.call(this);
  this.msg = msg;
}
protoOf(InvalidRequest).y20 = function () {
  return this.msg;
};
protoOf(InvalidRequest).xc = function () {
  return this.msg;
};
protoOf(InvalidRequest).q23 = function (msg) {
  return new InvalidRequest(msg);
};
protoOf(InvalidRequest).copy = function (msg, $super) {
  msg = msg === VOID ? this.msg : msg;
  return this.q23(msg);
};
protoOf(InvalidRequest).toString = function () {
  return 'InvalidRequest(msg=' + this.msg + ')';
};
protoOf(InvalidRequest).hashCode = function () {
  return getStringHashCode(this.msg);
};
protoOf(InvalidRequest).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof InvalidRequest)) return false;
  var tmp0_other_with_cast = other instanceof InvalidRequest ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  return true;
};
function Timeout(msg) {
  Interop.call(this);
  this.msg = msg;
}
protoOf(Timeout).y20 = function () {
  return this.msg;
};
protoOf(Timeout).xc = function () {
  return this.msg;
};
protoOf(Timeout).q23 = function (msg) {
  return new Timeout(msg);
};
protoOf(Timeout).copy = function (msg, $super) {
  msg = msg === VOID ? this.msg : msg;
  return this.q23(msg);
};
protoOf(Timeout).toString = function () {
  return 'Timeout(msg=' + this.msg + ')';
};
protoOf(Timeout).hashCode = function () {
  return getStringHashCode(this.msg);
};
protoOf(Timeout).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Timeout)) return false;
  var tmp0_other_with_cast = other instanceof Timeout ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  return true;
};
function HandlerException(msg) {
  Interop.call(this);
  this.msg = msg;
}
protoOf(HandlerException).y20 = function () {
  return this.msg;
};
protoOf(HandlerException).xc = function () {
  return this.msg;
};
protoOf(HandlerException).q23 = function (msg) {
  return new HandlerException(msg);
};
protoOf(HandlerException).copy = function (msg, $super) {
  msg = msg === VOID ? this.msg : msg;
  return this.q23(msg);
};
protoOf(HandlerException).toString = function () {
  return 'HandlerException(msg=' + this.msg + ')';
};
protoOf(HandlerException).hashCode = function () {
  return getStringHashCode(this.msg);
};
protoOf(HandlerException).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof HandlerException)) return false;
  var tmp0_other_with_cast = other instanceof HandlerException ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  return true;
};
function Unsupported() {
  Unsupported_instance = this;
  IpcError.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.z23_1 = lazy(tmp_0, IpcError$Interop$Unsupported$_anonymous__gw5cip);
}
protoOf(Unsupported).m15 = function () {
  return _get_$cachedSerializer__te6jhj_3(this);
};
protoOf(Unsupported).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(Unsupported).toString = function () {
  return 'Unsupported';
};
protoOf(Unsupported).hashCode = function () {
  return 810096890;
};
protoOf(Unsupported).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Unsupported)) return false;
  other instanceof Unsupported || THROW_CCE();
  return true;
};
var Unsupported_instance;
function Unsupported_getInstance() {
  if (Unsupported_instance == null) new Unsupported();
  return Unsupported_instance;
}
function UnknownResponseError() {
  UnknownResponseError_instance = this;
  Interop.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.z21_1 = lazy(tmp_0, IpcError$Interop$UnknownResponseError$_anonymous__i8uymz);
}
protoOf(UnknownResponseError).m15 = function () {
  return _get_$cachedSerializer__te6jhj_4(this);
};
protoOf(UnknownResponseError).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(UnknownResponseError).toString = function () {
  return 'UnknownResponseError';
};
protoOf(UnknownResponseError).hashCode = function () {
  return -1864011528;
};
protoOf(UnknownResponseError).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof UnknownResponseError)) return false;
  other instanceof UnknownResponseError || THROW_CCE();
  return true;
};
var UnknownResponseError_instance;
function UnknownResponseError_getInstance() {
  if (UnknownResponseError_instance == null) new UnknownResponseError();
  return UnknownResponseError_instance;
}
function Companion_11() {
  Companion_instance_11 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.a24_1 = lazy(tmp_0, IpcError$Interop$Companion$_anonymous__8tw4ja);
}
protoOf(Companion_11).m15 = function () {
  return _get_$cachedSerializer__te6jhj_5(this);
};
protoOf(Companion_11).bu = function (typeParamsSerializers) {
  return this.m15();
};
var Companion_instance_11;
function Companion_getInstance_12() {
  if (Companion_instance_11 == null) new Companion_11();
  return Companion_instance_11;
}
function Companion_12() {}
protoOf(Companion_12).m15 = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_12;
function Companion_getInstance_13() {
  return Companion_instance_12;
}
function $serializer_9() {
  $serializer_instance_8 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.error.IpcError.Network.Unknown', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.b24_1 = tmp0_serialDesc;
}
protoOf($serializer_9).c24 = function (encoder, value) {
  var tmp0_desc = this.b24_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.msg);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_9).bj = function (encoder, value) {
  return this.c24(encoder, value instanceof Unknown_0 ? value : THROW_CCE());
};
protoOf($serializer_9).cj = function (decoder) {
  var tmp0_desc = this.b24_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Unknown_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_9).aj = function () {
  return this.b24_1;
};
protoOf($serializer_9).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 == null) new $serializer_9();
  return $serializer_instance_8;
}
function Unknown_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_8().b24_1);
  }
  $this.msg = msg;
  return $this;
}
function Unknown_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return Unknown_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(Unknown_0)));
}
function _get_$cachedSerializer__te6jhj_6($this) {
  return $this.d24_1.s1();
}
function IpcError$Network$Companion$_anonymous__vyouvt() {
  var tmp = getKClass(Network);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Unknown_0)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_8()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer_init_$Create$('ipc.error.IpcError.Network', tmp, tmp_0, tmp_1, tmp$ret$8);
}
function Unknown_0(msg) {
  Network.call(this);
  this.msg = msg;
}
protoOf(Unknown_0).y20 = function () {
  return this.msg;
};
protoOf(Unknown_0).xc = function () {
  return this.msg;
};
protoOf(Unknown_0).q23 = function (msg) {
  return new Unknown_0(msg);
};
protoOf(Unknown_0).copy = function (msg, $super) {
  msg = msg === VOID ? this.msg : msg;
  return this.q23(msg);
};
protoOf(Unknown_0).toString = function () {
  return 'Unknown(msg=' + this.msg + ')';
};
protoOf(Unknown_0).hashCode = function () {
  return getStringHashCode(this.msg);
};
protoOf(Unknown_0).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Unknown_0)) return false;
  var tmp0_other_with_cast = other instanceof Unknown_0 ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  return true;
};
function Companion_13() {
  Companion_instance_13 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.d24_1 = lazy(tmp_0, IpcError$Network$Companion$_anonymous__vyouvt);
}
protoOf(Companion_13).m15 = function () {
  return _get_$cachedSerializer__te6jhj_6(this);
};
protoOf(Companion_13).bu = function (typeParamsSerializers) {
  return this.m15();
};
var Companion_instance_13;
function Companion_getInstance_14() {
  if (Companion_instance_13 == null) new Companion_13();
  return Companion_instance_13;
}
function _get_$cachedSerializer__te6jhj_7($this) {
  return $this.o21_1.s1();
}
function IpcError$Companion$_anonymous__nceo8z() {
  var tmp = getKClass(IpcError);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Generic), getKClass(HandlerException), getKClass(InvalidRequest), getKClass(Timeout), getKClass(UnknownResponseError), getKClass(Unsupported), getKClass(Unknown_0)];
  var tmp_1 = $serializer_getInstance_4();
  var tmp_2 = $serializer_getInstance_7();
  var tmp_3 = $serializer_getInstance_5();
  var tmp_4 = $serializer_getInstance_6();
  var tmp_5 = UnknownResponseError_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  var tmp_6 = ObjectSerializer_init_$Create$('ipc.error.IpcError.Interop.UnknownResponseError', tmp_5, tmp$ret$5);
  var tmp_7 = Unsupported_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_8 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_6, ObjectSerializer_init_$Create$('ipc.error.IpcError.Interop.Unsupported', tmp_7, tmp$ret$8), $serializer_getInstance_8()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = [];
  return SealedClassSerializer_init_$Create$('ipc.error.IpcError', tmp, tmp_0, tmp_8, tmp$ret$14);
}
function Generic(message) {
  IpcError.call(this);
  this.message = message;
}
protoOf(Generic).v8 = function () {
  return this.message;
};
protoOf(Generic).xc = function () {
  return this.message;
};
protoOf(Generic).q23 = function (message) {
  return new Generic(message);
};
protoOf(Generic).copy = function (message, $super) {
  message = message === VOID ? this.message : message;
  return this.q23(message);
};
protoOf(Generic).toString = function () {
  return 'Generic(message=' + this.message + ')';
};
protoOf(Generic).hashCode = function () {
  return getStringHashCode(this.message);
};
protoOf(Generic).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Generic)) return false;
  var tmp0_other_with_cast = other instanceof Generic ? other : THROW_CCE();
  if (!(this.message === tmp0_other_with_cast.message)) return false;
  return true;
};
function Interop() {
  Companion_getInstance_12();
  IpcError.call(this);
}
function Network() {
  Companion_getInstance_14();
  IpcError.call(this);
}
function Companion_14() {
  Companion_instance_14 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.o21_1 = lazy(tmp_0, IpcError$Companion$_anonymous__nceo8z);
}
protoOf(Companion_14).m15 = function () {
  return _get_$cachedSerializer__te6jhj_7(this);
};
protoOf(Companion_14).bu = function (typeParamsSerializers) {
  return this.m15();
};
var Companion_instance_14;
function Companion_getInstance_15() {
  if (Companion_instance_14 == null) new Companion_14();
  return Companion_instance_14;
}
function IpcError() {
  Companion_getInstance_15();
}
function Companion_15() {}
protoOf(Companion_15).m15 = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_15;
function Companion_getInstance_16() {
  return Companion_instance_15;
}
function $serializer_10() {
  $serializer_instance_9 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.AppConnectInfo', this, 2);
  tmp0_serialDesc.mt('appDebugInfo', false);
  tmp0_serialDesc.mt('supports', false);
  this.e24_1 = tmp0_serialDesc;
}
protoOf($serializer_10).f24 = function (encoder, value) {
  var tmp0_desc = this.e24_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.vn(tmp0_desc, 0, $serializer_getInstance_10(), value.appDebugInfo);
  tmp1_output.vn(tmp0_desc, 1, $serializer_getInstance_11(), value.supports);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_10).bj = function (encoder, value) {
  return this.f24(encoder, value instanceof AppConnectInfo ? value : THROW_CCE());
};
protoOf($serializer_10).cj = function (decoder) {
  var tmp0_desc = this.e24_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.fm(tmp0_desc);
  if (tmp6_input.vm()) {
    tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, $serializer_getInstance_11(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else while (tmp1_flag) {
    tmp2_index = tmp6_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp6_input.rm(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, $serializer_getInstance_11(), tmp5_local1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp6_input.gm(tmp0_desc);
  return AppConnectInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_10).aj = function () {
  return this.e24_1;
};
protoOf($serializer_10).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_10(), $serializer_getInstance_11()];
};
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 == null) new $serializer_10();
  return $serializer_instance_9;
}
function AppConnectInfo_init_$Init$(seen0, appDebugInfo, supports, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_9().e24_1);
  }
  $this.appDebugInfo = appDebugInfo;
  $this.supports = supports;
  return $this;
}
function AppConnectInfo_init_$Create$(seen0, appDebugInfo, supports, serializationConstructorMarker) {
  return AppConnectInfo_init_$Init$(seen0, appDebugInfo, supports, serializationConstructorMarker, objectCreate(protoOf(AppConnectInfo)));
}
function AppConnectInfo(appDebugInfo, supports) {
  this.appDebugInfo = appDebugInfo;
  this.supports = supports;
}
protoOf(AppConnectInfo).g24 = function () {
  return this.appDebugInfo;
};
protoOf(AppConnectInfo).h24 = function () {
  return this.supports;
};
protoOf(AppConnectInfo).xc = function () {
  return this.appDebugInfo;
};
protoOf(AppConnectInfo).yc = function () {
  return this.supports;
};
protoOf(AppConnectInfo).i24 = function (appDebugInfo, supports) {
  return new AppConnectInfo(appDebugInfo, supports);
};
protoOf(AppConnectInfo).copy = function (appDebugInfo, supports, $super) {
  appDebugInfo = appDebugInfo === VOID ? this.appDebugInfo : appDebugInfo;
  supports = supports === VOID ? this.supports : supports;
  return this.i24(appDebugInfo, supports);
};
protoOf(AppConnectInfo).toString = function () {
  return 'AppConnectInfo(appDebugInfo=' + this.appDebugInfo.toString() + ', supports=' + this.supports.toString() + ')';
};
protoOf(AppConnectInfo).hashCode = function () {
  var result = this.appDebugInfo.hashCode();
  result = imul(result, 31) + this.supports.hashCode() | 0;
  return result;
};
protoOf(AppConnectInfo).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof AppConnectInfo)) return false;
  var tmp0_other_with_cast = other instanceof AppConnectInfo ? other : THROW_CCE();
  if (!this.appDebugInfo.equals(tmp0_other_with_cast.appDebugInfo)) return false;
  if (!this.supports.equals(tmp0_other_with_cast.supports)) return false;
  return true;
};
function Companion_16() {}
protoOf(Companion_16).m15 = function () {
  return $serializer_getInstance_10();
};
var Companion_instance_16;
function Companion_getInstance_17() {
  return Companion_instance_16;
}
function $serializer_11() {
  $serializer_instance_10 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.AppDebugInfo', this, 2);
  tmp0_serialDesc.mt('agentId', false);
  tmp0_serialDesc.mt('agentVersionName', false);
  this.j24_1 = tmp0_serialDesc;
}
protoOf($serializer_11).k24 = function (encoder, value) {
  var tmp0_desc = this.j24_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.agentId);
  tmp1_output.tn(tmp0_desc, 1, value.agentVersionName);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_11).bj = function (encoder, value) {
  return this.k24(encoder, value instanceof AppDebugInfo ? value : THROW_CCE());
};
protoOf($serializer_11).cj = function (decoder) {
  var tmp0_desc = this.j24_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.fm(tmp0_desc);
  if (tmp6_input.vm()) {
    tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else while (tmp1_flag) {
    tmp2_index = tmp6_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp6_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp6_input.pm(tmp0_desc, 1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp6_input.gm(tmp0_desc);
  return AppDebugInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_11).aj = function () {
  return this.j24_1;
};
protoOf($serializer_11).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 == null) new $serializer_11();
  return $serializer_instance_10;
}
function AppDebugInfo_init_$Init$(seen0, agentId, agentVersionName, serializationConstructorMarker, $this) {
  if (!(3 === (3 & seen0))) {
    throwMissingFieldException(seen0, 3, $serializer_getInstance_10().j24_1);
  }
  $this.agentId = agentId;
  $this.agentVersionName = agentVersionName;
  return $this;
}
function AppDebugInfo_init_$Create$(seen0, agentId, agentVersionName, serializationConstructorMarker) {
  return AppDebugInfo_init_$Init$(seen0, agentId, agentVersionName, serializationConstructorMarker, objectCreate(protoOf(AppDebugInfo)));
}
function AppDebugInfo(agentId, agentVersionName) {
  this.agentId = agentId;
  this.agentVersionName = agentVersionName;
}
protoOf(AppDebugInfo).l24 = function () {
  return this.agentId;
};
protoOf(AppDebugInfo).m24 = function () {
  return this.agentVersionName;
};
protoOf(AppDebugInfo).xc = function () {
  return this.agentId;
};
protoOf(AppDebugInfo).yc = function () {
  return this.agentVersionName;
};
protoOf(AppDebugInfo).n24 = function (agentId, agentVersionName) {
  return new AppDebugInfo(agentId, agentVersionName);
};
protoOf(AppDebugInfo).copy = function (agentId, agentVersionName, $super) {
  agentId = agentId === VOID ? this.agentId : agentId;
  agentVersionName = agentVersionName === VOID ? this.agentVersionName : agentVersionName;
  return this.n24(agentId, agentVersionName);
};
protoOf(AppDebugInfo).toString = function () {
  return 'AppDebugInfo(agentId=' + this.agentId + ', agentVersionName=' + this.agentVersionName + ')';
};
protoOf(AppDebugInfo).hashCode = function () {
  var result = getStringHashCode(this.agentId);
  result = imul(result, 31) + getStringHashCode(this.agentVersionName) | 0;
  return result;
};
protoOf(AppDebugInfo).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof AppDebugInfo)) return false;
  var tmp0_other_with_cast = other instanceof AppDebugInfo ? other : THROW_CCE();
  if (!(this.agentId === tmp0_other_with_cast.agentId)) return false;
  if (!(this.agentVersionName === tmp0_other_with_cast.agentVersionName)) return false;
  return true;
};
function Companion_17() {}
protoOf(Companion_17).m15 = function () {
  return $serializer_getInstance_11();
};
var Companion_instance_17;
function Companion_getInstance_18() {
  return Companion_instance_17;
}
function $serializer_12() {
  $serializer_instance_11 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.AppFeatureManifest', this, 2);
  tmp0_serialDesc.mt('hideNativeLoading', true);
  tmp0_serialDesc.mt('biometrics', true);
  this.o24_1 = tmp0_serialDesc;
}
protoOf($serializer_12).p24 = function (encoder, value) {
  var tmp0_desc = this.o24_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  if (tmp1_output.bo(tmp0_desc, 0) ? true : !(value.hideNativeLoading === false)) {
    tmp1_output.ln(tmp0_desc, 0, value.hideNativeLoading);
  }
  if (tmp1_output.bo(tmp0_desc, 1) ? true : !value.biometrics.equals(new BiometricFeatures())) {
    tmp1_output.vn(tmp0_desc, 1, $serializer_getInstance_12(), value.biometrics);
  }
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_12).bj = function (encoder, value) {
  return this.p24(encoder, value instanceof AppFeatureManifest ? value : THROW_CCE());
};
protoOf($serializer_12).cj = function (decoder) {
  var tmp0_desc = this.o24_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_local1 = null;
  var tmp6_input = decoder.fm(tmp0_desc);
  if (tmp6_input.vm()) {
    tmp4_local0 = tmp6_input.hm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else while (tmp1_flag) {
    tmp2_index = tmp6_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp6_input.hm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp6_input.rm(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp6_input.gm(tmp0_desc);
  return AppFeatureManifest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_12).aj = function () {
  return this.o24_1;
};
protoOf($serializer_12).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance(), $serializer_getInstance_12()];
};
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 == null) new $serializer_12();
  return $serializer_instance_11;
}
function AppFeatureManifest_init_$Init$(seen0, hideNativeLoading, biometrics, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_11().o24_1);
  }
  if (0 === (seen0 & 1)) $this.hideNativeLoading = false;else $this.hideNativeLoading = hideNativeLoading;
  if (0 === (seen0 & 2)) $this.biometrics = new BiometricFeatures();else $this.biometrics = biometrics;
  return $this;
}
function AppFeatureManifest_init_$Create$(seen0, hideNativeLoading, biometrics, serializationConstructorMarker) {
  return AppFeatureManifest_init_$Init$(seen0, hideNativeLoading, biometrics, serializationConstructorMarker, objectCreate(protoOf(AppFeatureManifest)));
}
function AppFeatureManifest(hideNativeLoading, biometrics) {
  hideNativeLoading = hideNativeLoading === VOID ? false : hideNativeLoading;
  biometrics = biometrics === VOID ? new BiometricFeatures() : biometrics;
  this.hideNativeLoading = hideNativeLoading;
  this.biometrics = biometrics;
}
protoOf(AppFeatureManifest).q24 = function () {
  return this.hideNativeLoading;
};
protoOf(AppFeatureManifest).r24 = function () {
  return this.biometrics;
};
protoOf(AppFeatureManifest).xc = function () {
  return this.hideNativeLoading;
};
protoOf(AppFeatureManifest).yc = function () {
  return this.biometrics;
};
protoOf(AppFeatureManifest).s24 = function (hideNativeLoading, biometrics) {
  return new AppFeatureManifest(hideNativeLoading, biometrics);
};
protoOf(AppFeatureManifest).copy = function (hideNativeLoading, biometrics, $super) {
  hideNativeLoading = hideNativeLoading === VOID ? this.hideNativeLoading : hideNativeLoading;
  biometrics = biometrics === VOID ? this.biometrics : biometrics;
  return this.s24(hideNativeLoading, biometrics);
};
protoOf(AppFeatureManifest).toString = function () {
  return 'AppFeatureManifest(hideNativeLoading=' + this.hideNativeLoading + ', biometrics=' + this.biometrics.toString() + ')';
};
protoOf(AppFeatureManifest).hashCode = function () {
  var result = getBooleanHashCode(this.hideNativeLoading);
  result = imul(result, 31) + this.biometrics.hashCode() | 0;
  return result;
};
protoOf(AppFeatureManifest).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof AppFeatureManifest)) return false;
  var tmp0_other_with_cast = other instanceof AppFeatureManifest ? other : THROW_CCE();
  if (!(this.hideNativeLoading === tmp0_other_with_cast.hideNativeLoading)) return false;
  if (!this.biometrics.equals(tmp0_other_with_cast.biometrics)) return false;
  return true;
};
function Companion_18() {}
protoOf(Companion_18).m15 = function () {
  return $serializer_getInstance_12();
};
var Companion_instance_18;
function Companion_getInstance_19() {
  return Companion_instance_18;
}
function $serializer_13() {
  $serializer_instance_12 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.BiometricFeatures', this, 3);
  tmp0_serialDesc.mt('queryAvailability', true);
  tmp0_serialDesc.mt('enrollDevice', true);
  tmp0_serialDesc.mt('payloadSigning', true);
  this.t24_1 = tmp0_serialDesc;
}
protoOf($serializer_13).u24 = function (encoder, value) {
  var tmp0_desc = this.t24_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  if (tmp1_output.bo(tmp0_desc, 0) ? true : !(value.queryAvailability === false)) {
    tmp1_output.ln(tmp0_desc, 0, value.queryAvailability);
  }
  if (tmp1_output.bo(tmp0_desc, 1) ? true : !(value.enrollDevice === false)) {
    tmp1_output.ln(tmp0_desc, 1, value.enrollDevice);
  }
  if (tmp1_output.bo(tmp0_desc, 2) ? true : !(value.payloadSigning === false)) {
    tmp1_output.ln(tmp0_desc, 2, value.payloadSigning);
  }
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_13).bj = function (encoder, value) {
  return this.u24(encoder, value instanceof BiometricFeatures ? value : THROW_CCE());
};
protoOf($serializer_13).cj = function (decoder) {
  var tmp0_desc = this.t24_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_local1 = false;
  var tmp6_local2 = false;
  var tmp7_input = decoder.fm(tmp0_desc);
  if (tmp7_input.vm()) {
    tmp4_local0 = tmp7_input.hm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.hm(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else while (tmp1_flag) {
    tmp2_index = tmp7_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp7_input.hm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp7_input.hm(tmp0_desc, 1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      case 2:
        tmp6_local2 = tmp7_input.hm(tmp0_desc, 2);
        tmp3_bitMask0 = tmp3_bitMask0 | 4;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp7_input.gm(tmp0_desc);
  return BiometricFeatures_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_13).aj = function () {
  return this.t24_1;
};
protoOf($serializer_13).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
};
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 == null) new $serializer_13();
  return $serializer_instance_12;
}
function BiometricFeatures_init_$Init$(seen0, queryAvailability, enrollDevice, payloadSigning, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_12().t24_1);
  }
  if (0 === (seen0 & 1)) $this.queryAvailability = false;else $this.queryAvailability = queryAvailability;
  if (0 === (seen0 & 2)) $this.enrollDevice = false;else $this.enrollDevice = enrollDevice;
  if (0 === (seen0 & 4)) $this.payloadSigning = false;else $this.payloadSigning = payloadSigning;
  return $this;
}
function BiometricFeatures_init_$Create$(seen0, queryAvailability, enrollDevice, payloadSigning, serializationConstructorMarker) {
  return BiometricFeatures_init_$Init$(seen0, queryAvailability, enrollDevice, payloadSigning, serializationConstructorMarker, objectCreate(protoOf(BiometricFeatures)));
}
function BiometricFeatures(queryAvailability, enrollDevice, payloadSigning) {
  queryAvailability = queryAvailability === VOID ? false : queryAvailability;
  enrollDevice = enrollDevice === VOID ? false : enrollDevice;
  payloadSigning = payloadSigning === VOID ? false : payloadSigning;
  this.queryAvailability = queryAvailability;
  this.enrollDevice = enrollDevice;
  this.payloadSigning = payloadSigning;
}
protoOf(BiometricFeatures).v24 = function () {
  return this.queryAvailability;
};
protoOf(BiometricFeatures).w24 = function () {
  return this.enrollDevice;
};
protoOf(BiometricFeatures).x24 = function () {
  return this.payloadSigning;
};
protoOf(BiometricFeatures).xc = function () {
  return this.queryAvailability;
};
protoOf(BiometricFeatures).yc = function () {
  return this.enrollDevice;
};
protoOf(BiometricFeatures).y24 = function () {
  return this.payloadSigning;
};
protoOf(BiometricFeatures).z24 = function (queryAvailability, enrollDevice, payloadSigning) {
  return new BiometricFeatures(queryAvailability, enrollDevice, payloadSigning);
};
protoOf(BiometricFeatures).copy = function (queryAvailability, enrollDevice, payloadSigning, $super) {
  queryAvailability = queryAvailability === VOID ? this.queryAvailability : queryAvailability;
  enrollDevice = enrollDevice === VOID ? this.enrollDevice : enrollDevice;
  payloadSigning = payloadSigning === VOID ? this.payloadSigning : payloadSigning;
  return this.z24(queryAvailability, enrollDevice, payloadSigning);
};
protoOf(BiometricFeatures).toString = function () {
  return 'BiometricFeatures(queryAvailability=' + this.queryAvailability + ', enrollDevice=' + this.enrollDevice + ', payloadSigning=' + this.payloadSigning + ')';
};
protoOf(BiometricFeatures).hashCode = function () {
  var result = getBooleanHashCode(this.queryAvailability);
  result = imul(result, 31) + getBooleanHashCode(this.enrollDevice) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.payloadSigning) | 0;
  return result;
};
protoOf(BiometricFeatures).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof BiometricFeatures)) return false;
  var tmp0_other_with_cast = other instanceof BiometricFeatures ? other : THROW_CCE();
  if (!(this.queryAvailability === tmp0_other_with_cast.queryAvailability)) return false;
  if (!(this.enrollDevice === tmp0_other_with_cast.enrollDevice)) return false;
  if (!(this.payloadSigning === tmp0_other_with_cast.payloadSigning)) return false;
  return true;
};
function Companion_19() {}
function $serializer_14() {
  $serializer_instance_13 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.IpcConnectReply', this, 1);
  tmp0_serialDesc.mt('connectInfo', false);
  this.a25_1 = tmp0_serialDesc;
}
protoOf($serializer_14).b25 = function (encoder, value) {
  var tmp0_desc = this.a25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.vn(tmp0_desc, 0, $serializer_getInstance_9(), value.c25_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_14).bj = function (encoder, value) {
  return this.b25(encoder, value instanceof IpcConnectReply ? value : THROW_CCE());
};
protoOf($serializer_14).cj = function (decoder) {
  var tmp0_desc = this.a25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return IpcConnectReply_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_14).aj = function () {
  return this.a25_1;
};
protoOf($serializer_14).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_9()];
};
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 == null) new $serializer_14();
  return $serializer_instance_13;
}
function IpcConnectReply_init_$Init$(seen0, connectInfo, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_13().a25_1);
  }
  $this.c25_1 = connectInfo;
  return $this;
}
function IpcConnectReply_init_$Create$(seen0, connectInfo, serializationConstructorMarker) {
  return IpcConnectReply_init_$Init$(seen0, connectInfo, serializationConstructorMarker, objectCreate(protoOf(IpcConnectReply)));
}
function IpcConnectReply(connectInfo) {
  this.c25_1 = connectInfo;
}
protoOf(IpcConnectReply).toString = function () {
  return 'IpcConnectReply(connectInfo=' + this.c25_1.toString() + ')';
};
protoOf(IpcConnectReply).hashCode = function () {
  return this.c25_1.hashCode();
};
protoOf(IpcConnectReply).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcConnectReply)) return false;
  var tmp0_other_with_cast = other instanceof IpcConnectReply ? other : THROW_CCE();
  if (!this.c25_1.equals(tmp0_other_with_cast.c25_1)) return false;
  return true;
};
function Companion_20() {}
protoOf(Companion_20).m15 = function () {
  return $serializer_getInstance_14();
};
var Companion_instance_20;
function Companion_getInstance_21() {
  return Companion_instance_20;
}
function $serializer_15() {
  $serializer_instance_14 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.IpcDigSigAvailabilityReply', this, 3);
  tmp0_serialDesc.mt('deviceEnrollmentAvailable', false);
  tmp0_serialDesc.mt('payloadSigningAvailable', false);
  tmp0_serialDesc.mt('deviceId', false);
  this.d25_1 = tmp0_serialDesc;
}
protoOf($serializer_15).e25 = function (encoder, value) {
  var tmp0_desc = this.d25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.ln(tmp0_desc, 0, value.deviceEnrollmentAvailable);
  tmp1_output.ln(tmp0_desc, 1, value.payloadSigningAvailable);
  tmp1_output.tn(tmp0_desc, 2, value.deviceId);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_15).bj = function (encoder, value) {
  return this.e25(encoder, value instanceof IpcDigSigAvailabilityReply ? value : THROW_CCE());
};
protoOf($serializer_15).cj = function (decoder) {
  var tmp0_desc = this.d25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_local1 = false;
  var tmp6_local2 = null;
  var tmp7_input = decoder.fm(tmp0_desc);
  if (tmp7_input.vm()) {
    tmp4_local0 = tmp7_input.hm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.hm(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else while (tmp1_flag) {
    tmp2_index = tmp7_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp7_input.hm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      case 1:
        tmp5_local1 = tmp7_input.hm(tmp0_desc, 1);
        tmp3_bitMask0 = tmp3_bitMask0 | 2;
        break;
      case 2:
        tmp6_local2 = tmp7_input.pm(tmp0_desc, 2);
        tmp3_bitMask0 = tmp3_bitMask0 | 4;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp7_input.gm(tmp0_desc);
  return IpcDigSigAvailabilityReply_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_15).aj = function () {
  return this.d25_1;
};
protoOf($serializer_15).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 == null) new $serializer_15();
  return $serializer_instance_14;
}
function IpcDigSigAvailabilityReply_init_$Init$(seen0, deviceEnrollmentAvailable, payloadSigningAvailable, deviceId, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance_14().d25_1);
  }
  $this.deviceEnrollmentAvailable = deviceEnrollmentAvailable;
  $this.payloadSigningAvailable = payloadSigningAvailable;
  $this.deviceId = deviceId;
  return $this;
}
function IpcDigSigAvailabilityReply_init_$Create$(seen0, deviceEnrollmentAvailable, payloadSigningAvailable, deviceId, serializationConstructorMarker) {
  return IpcDigSigAvailabilityReply_init_$Init$(seen0, deviceEnrollmentAvailable, payloadSigningAvailable, deviceId, serializationConstructorMarker, objectCreate(protoOf(IpcDigSigAvailabilityReply)));
}
function IpcDigSigAvailabilityReply(deviceEnrollmentAvailable, payloadSigningAvailable, deviceId) {
  this.deviceEnrollmentAvailable = deviceEnrollmentAvailable;
  this.payloadSigningAvailable = payloadSigningAvailable;
  this.deviceId = deviceId;
}
protoOf(IpcDigSigAvailabilityReply).f25 = function () {
  return this.deviceEnrollmentAvailable;
};
protoOf(IpcDigSigAvailabilityReply).g25 = function () {
  return this.payloadSigningAvailable;
};
protoOf(IpcDigSigAvailabilityReply).h25 = function () {
  return this.deviceId;
};
protoOf(IpcDigSigAvailabilityReply).xc = function () {
  return this.deviceEnrollmentAvailable;
};
protoOf(IpcDigSigAvailabilityReply).yc = function () {
  return this.payloadSigningAvailable;
};
protoOf(IpcDigSigAvailabilityReply).y24 = function () {
  return this.deviceId;
};
protoOf(IpcDigSigAvailabilityReply).i25 = function (deviceEnrollmentAvailable, payloadSigningAvailable, deviceId) {
  return new IpcDigSigAvailabilityReply(deviceEnrollmentAvailable, payloadSigningAvailable, deviceId);
};
protoOf(IpcDigSigAvailabilityReply).copy = function (deviceEnrollmentAvailable, payloadSigningAvailable, deviceId, $super) {
  deviceEnrollmentAvailable = deviceEnrollmentAvailable === VOID ? this.deviceEnrollmentAvailable : deviceEnrollmentAvailable;
  payloadSigningAvailable = payloadSigningAvailable === VOID ? this.payloadSigningAvailable : payloadSigningAvailable;
  deviceId = deviceId === VOID ? this.deviceId : deviceId;
  return this.i25(deviceEnrollmentAvailable, payloadSigningAvailable, deviceId);
};
protoOf(IpcDigSigAvailabilityReply).toString = function () {
  return 'IpcDigSigAvailabilityReply(deviceEnrollmentAvailable=' + this.deviceEnrollmentAvailable + ', payloadSigningAvailable=' + this.payloadSigningAvailable + ', deviceId=' + this.deviceId + ')';
};
protoOf(IpcDigSigAvailabilityReply).hashCode = function () {
  var result = getBooleanHashCode(this.deviceEnrollmentAvailable);
  result = imul(result, 31) + getBooleanHashCode(this.payloadSigningAvailable) | 0;
  result = imul(result, 31) + getStringHashCode(this.deviceId) | 0;
  return result;
};
protoOf(IpcDigSigAvailabilityReply).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcDigSigAvailabilityReply)) return false;
  var tmp0_other_with_cast = other instanceof IpcDigSigAvailabilityReply ? other : THROW_CCE();
  if (!(this.deviceEnrollmentAvailable === tmp0_other_with_cast.deviceEnrollmentAvailable)) return false;
  if (!(this.payloadSigningAvailable === tmp0_other_with_cast.payloadSigningAvailable)) return false;
  if (!(this.deviceId === tmp0_other_with_cast.deviceId)) return false;
  return true;
};
function Companion_21() {}
protoOf(Companion_21).m15 = function () {
  return $serializer_getInstance_15();
};
var Companion_instance_21;
function Companion_getInstance_22() {
  return Companion_instance_21;
}
function $serializer_16() {
  $serializer_instance_15 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.IpcDigSigSignPayloadReply', this, 1);
  tmp0_serialDesc.mt('signature', false);
  this.j25_1 = tmp0_serialDesc;
}
protoOf($serializer_16).k25 = function (encoder, value) {
  var tmp0_desc = this.j25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.signature);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_16).bj = function (encoder, value) {
  return this.k25(encoder, value instanceof IpcDigSigSignPayloadReply ? value : THROW_CCE());
};
protoOf($serializer_16).cj = function (decoder) {
  var tmp0_desc = this.j25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return IpcDigSigSignPayloadReply_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_16).aj = function () {
  return this.j25_1;
};
protoOf($serializer_16).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 == null) new $serializer_16();
  return $serializer_instance_15;
}
function IpcDigSigSignPayloadReply_init_$Init$(seen0, signature, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_15().j25_1);
  }
  $this.signature = signature;
  return $this;
}
function IpcDigSigSignPayloadReply_init_$Create$(seen0, signature, serializationConstructorMarker) {
  return IpcDigSigSignPayloadReply_init_$Init$(seen0, signature, serializationConstructorMarker, objectCreate(protoOf(IpcDigSigSignPayloadReply)));
}
function IpcDigSigSignPayloadReply(signature) {
  this.signature = signature;
}
protoOf(IpcDigSigSignPayloadReply).l25 = function () {
  return this.signature;
};
protoOf(IpcDigSigSignPayloadReply).xc = function () {
  return this.signature;
};
protoOf(IpcDigSigSignPayloadReply).q23 = function (signature) {
  return new IpcDigSigSignPayloadReply(signature);
};
protoOf(IpcDigSigSignPayloadReply).copy = function (signature, $super) {
  signature = signature === VOID ? this.signature : signature;
  return this.q23(signature);
};
protoOf(IpcDigSigSignPayloadReply).toString = function () {
  return 'IpcDigSigSignPayloadReply(signature=' + this.signature + ')';
};
protoOf(IpcDigSigSignPayloadReply).hashCode = function () {
  return getStringHashCode(this.signature);
};
protoOf(IpcDigSigSignPayloadReply).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcDigSigSignPayloadReply)) return false;
  var tmp0_other_with_cast = other instanceof IpcDigSigSignPayloadReply ? other : THROW_CCE();
  if (!(this.signature === tmp0_other_with_cast.signature)) return false;
  return true;
};
function Companion_22() {}
protoOf(Companion_22).m15 = function () {
  return $serializer_getInstance_16();
};
var Companion_instance_22;
function Companion_getInstance_23() {
  return Companion_instance_22;
}
function $serializer_17() {
  $serializer_instance_16 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.reply.IpcPingReply', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.m25_1 = tmp0_serialDesc;
}
protoOf($serializer_17).n25 = function (encoder, value) {
  var tmp0_desc = this.m25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.msg);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_17).bj = function (encoder, value) {
  return this.n25(encoder, value instanceof IpcPingReply ? value : THROW_CCE());
};
protoOf($serializer_17).cj = function (decoder) {
  var tmp0_desc = this.m25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return IpcPingReply_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_17).aj = function () {
  return this.m25_1;
};
protoOf($serializer_17).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 == null) new $serializer_17();
  return $serializer_instance_16;
}
function IpcPingReply_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_16().m25_1);
  }
  $this.msg = msg;
  return $this;
}
function IpcPingReply_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return IpcPingReply_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(IpcPingReply)));
}
function IpcPingReply(msg) {
  this.msg = msg;
}
protoOf(IpcPingReply).y20 = function () {
  return this.msg;
};
protoOf(IpcPingReply).xc = function () {
  return this.msg;
};
protoOf(IpcPingReply).q23 = function (msg) {
  return new IpcPingReply(msg);
};
protoOf(IpcPingReply).copy = function (msg, $super) {
  msg = msg === VOID ? this.msg : msg;
  return this.q23(msg);
};
protoOf(IpcPingReply).toString = function () {
  return 'IpcPingReply(msg=' + this.msg + ')';
};
protoOf(IpcPingReply).hashCode = function () {
  return getStringHashCode(this.msg);
};
protoOf(IpcPingReply).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcPingReply)) return false;
  var tmp0_other_with_cast = other instanceof IpcPingReply ? other : THROW_CCE();
  if (!(this.msg === tmp0_other_with_cast.msg)) return false;
  return true;
};
function Companion_23() {}
protoOf(Companion_23).m15 = function () {
  var tmp = getKClass(IpcReply_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(IpcConnectReply), getKClass(IpcDigSigAvailabilityReply), getKClass(IpcDigSigSignPayloadReply), getKClass(IpcPingReply), getKClass(IpcVoid_0)];
  var tmp_1 = $serializer_getInstance_13();
  var tmp_2 = $serializer_getInstance_14();
  var tmp_3 = $serializer_getInstance_15();
  var tmp_4 = $serializer_getInstance_16();
  var tmp_5 = IpcVoid_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_6 = [tmp_1, tmp_2, tmp_3, tmp_4, ObjectSerializer_init_$Create$('ipc.reply.IpcVoid', tmp_5, tmp$ret$5)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  return SealedClassSerializer_init_$Create$('ipc.reply.IpcReply', tmp, tmp_0, tmp_6, tmp$ret$11);
};
protoOf(Companion_23).bu = function (typeParamsSerializers) {
  return this.m15();
};
var Companion_instance_23;
function Companion_getInstance_24() {
  return Companion_instance_23;
}
function IpcReply_0() {}
function _get_$cachedSerializer__te6jhj_8($this) {
  return $this.o25_1.s1();
}
function IpcVoid$_anonymous__h1seyh() {
  var tmp = IpcVoid_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.reply.IpcVoid', tmp, tmp$ret$2);
}
function IpcVoid_0() {
  IpcVoid_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.o25_1 = lazy(tmp_0, IpcVoid$_anonymous__h1seyh);
}
protoOf(IpcVoid_0).m15 = function () {
  return _get_$cachedSerializer__te6jhj_8(this);
};
protoOf(IpcVoid_0).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(IpcVoid_0).toString = function () {
  return 'IpcVoid';
};
protoOf(IpcVoid_0).hashCode = function () {
  return 651858522;
};
protoOf(IpcVoid_0).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcVoid_0)) return false;
  other instanceof IpcVoid_0 || THROW_CCE();
  return true;
};
var IpcVoid_instance;
function IpcVoid_getInstance() {
  if (IpcVoid_instance == null) new IpcVoid_0();
  return IpcVoid_instance;
}
function Companion_24() {}
function $serializer_18() {
  $serializer_instance_17 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.AppCmd.Ping', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.p25_1 = tmp0_serialDesc;
}
protoOf($serializer_18).q25 = function (encoder, value) {
  var tmp0_desc = this.p25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.e1v_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_18).bj = function (encoder, value) {
  return this.q25(encoder, value instanceof Ping ? value : THROW_CCE());
};
protoOf($serializer_18).cj = function (decoder) {
  var tmp0_desc = this.p25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Ping_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_18).aj = function () {
  return this.p25_1;
};
protoOf($serializer_18).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 == null) new $serializer_18();
  return $serializer_instance_17;
}
function Ping_init_$Init$(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_17().p25_1);
  }
  $this.e1v_1 = msg;
  return $this;
}
function Ping_init_$Create$(seen0, msg, serializationConstructorMarker) {
  return Ping_init_$Init$(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(Ping)));
}
function _get_$cachedSerializer__te6jhj_9($this) {
  return $this.r25_1.s1();
}
function AppCmd$Companion$_anonymous__iiv8c6() {
  var tmp = getKClass(AppCmd);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Ping)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = [$serializer_getInstance_17()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  return SealedClassSerializer_init_$Create$('ipc.req.AppCmd', tmp, tmp_0, tmp_1, tmp$ret$8);
}
function Ping(msg) {
  AppCmd.call(this);
  this.e1v_1 = msg;
}
protoOf(Ping).toString = function () {
  return 'Ping(msg=' + this.e1v_1 + ')';
};
protoOf(Ping).hashCode = function () {
  return getStringHashCode(this.e1v_1);
};
protoOf(Ping).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Ping)) return false;
  var tmp0_other_with_cast = other instanceof Ping ? other : THROW_CCE();
  if (!(this.e1v_1 === tmp0_other_with_cast.e1v_1)) return false;
  return true;
};
function Companion_25() {
  Companion_instance_25 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.r25_1 = lazy(tmp_0, AppCmd$Companion$_anonymous__iiv8c6);
}
protoOf(Companion_25).s25 = function (typeSerial0) {
  return _get_$cachedSerializer__te6jhj_9(this);
};
protoOf(Companion_25).bu = function (typeParamsSerializers) {
  return this.s25(typeParamsSerializers[0]);
};
var Companion_instance_25;
function Companion_getInstance_26() {
  if (Companion_instance_25 == null) new Companion_25();
  return Companion_instance_25;
}
function AppCmd() {
  Companion_getInstance_26();
  IpcRequest.call(this);
}
function Companion_26() {
  Companion_instance_26 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.t25_1 = [Companion_getInstance_15().m15()];
}
var Companion_instance_26;
function Companion_getInstance_27() {
  if (Companion_instance_26 == null) new Companion_26();
  return Companion_instance_26;
}
function $serializer_19() {
  $serializer_instance_18 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.IpcDebugErrorRequest', this, 1);
  tmp0_serialDesc.mt('error', false);
  this.u25_1 = tmp0_serialDesc;
}
protoOf($serializer_19).v25 = function (encoder, value) {
  var tmp0_desc = this.u25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  var tmp2_cached = Companion_getInstance_27().t25_1;
  tmp1_output.vn(tmp0_desc, 0, tmp2_cached[0], value.u1s_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_19).bj = function (encoder, value) {
  return this.v25(encoder, value instanceof IpcDebugErrorRequest ? value : THROW_CCE());
};
protoOf($serializer_19).cj = function (decoder) {
  var tmp0_desc = this.u25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  var tmp6_cached = Companion_getInstance_27().t25_1;
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return IpcDebugErrorRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_19).aj = function () {
  return this.u25_1;
};
protoOf($serializer_19).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_27().t25_1[0]];
};
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 == null) new $serializer_19();
  return $serializer_instance_18;
}
function IpcDebugErrorRequest_init_$Init$(seen0, error, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_18().u25_1);
  }
  $this.u1s_1 = error;
  return $this;
}
function IpcDebugErrorRequest_init_$Create$(seen0, error, serializationConstructorMarker) {
  return IpcDebugErrorRequest_init_$Init$(seen0, error, serializationConstructorMarker, objectCreate(protoOf(IpcDebugErrorRequest)));
}
function IpcDebugErrorRequest(error) {
  Companion_getInstance_27();
  IpcRequest.call(this);
  this.u1s_1 = error;
}
protoOf(IpcDebugErrorRequest).toString = function () {
  return 'IpcDebugErrorRequest(error=' + toString_1(this.u1s_1) + ')';
};
protoOf(IpcDebugErrorRequest).hashCode = function () {
  return hashCode(this.u1s_1);
};
protoOf(IpcDebugErrorRequest).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof IpcDebugErrorRequest)) return false;
  var tmp0_other_with_cast = other instanceof IpcDebugErrorRequest ? other : THROW_CCE();
  if (!equals(this.u1s_1, tmp0_other_with_cast.u1s_1)) return false;
  return true;
};
function _get_$cachedSerializer__te6jhj_10($this) {
  return $this.w25_1.s1();
}
function IpcRequest$Companion$_anonymous__v9ufb8() {
  var tmp = getKClass(IpcRequest);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(Ping), getKClass(IpcDebugErrorRequest), getKClass(UnknownRequest), getKClass(BeginSession), getKClass(Connect), getKClass(EndSession), getKClass(GetDigSigAvailability), getKClass(GetSignedPayload), getKClass(Ping_0), getKClass(StartDigSigEnrollment)];
  var tmp_1 = $serializer_getInstance_17();
  var tmp_2 = $serializer_getInstance_18();
  var tmp_3 = UnknownRequest_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  var tmp_4 = ObjectSerializer_init_$Create$('ipc.req.UnknownRequest', tmp_3, tmp$ret$5);
  var tmp_5 = $serializer_getInstance_19();
  var tmp_6 = $serializer_getInstance_20();
  var tmp_7 = $serializer_getInstance_21();
  var tmp_8 = GetDigSigAvailability_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  var tmp_9 = ObjectSerializer_init_$Create$('ipc.req.WebCmd.GetDigSigAvailability', tmp_8, tmp$ret$8);
  var tmp_10 = $serializer_getInstance_23();
  var tmp_11 = $serializer_getInstance_22();
  var tmp_12 = StartDigSigEnrollment_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$11 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_13 = [tmp_1, tmp_2, tmp_4, tmp_5, tmp_6, tmp_7, tmp_9, tmp_10, tmp_11, ObjectSerializer_init_$Create$('ipc.req.WebCmd.StartDigSigEnrollment', tmp_12, tmp$ret$11)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$17 = [];
  return SealedClassSerializer_init_$Create$('ipc.req.IpcRequest', tmp, tmp_0, tmp_13, tmp$ret$17);
}
function Companion_27() {
  Companion_instance_27 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.w25_1 = lazy(tmp_0, IpcRequest$Companion$_anonymous__v9ufb8);
}
protoOf(Companion_27).s25 = function (typeSerial0) {
  return _get_$cachedSerializer__te6jhj_10(this);
};
protoOf(Companion_27).bu = function (typeParamsSerializers) {
  return this.s25(typeParamsSerializers[0]);
};
var Companion_instance_27;
function Companion_getInstance_28() {
  if (Companion_instance_27 == null) new Companion_27();
  return Companion_instance_27;
}
function IpcRequest() {
  Companion_getInstance_28();
}
function _get_$cachedSerializer__te6jhj_11($this) {
  return $this.w21_1.s1();
}
function UnknownRequest$_anonymous__lw68b2() {
  var tmp = UnknownRequest_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.req.UnknownRequest', tmp, tmp$ret$2);
}
function UnknownRequest() {
  UnknownRequest_instance = this;
  IpcRequest.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.w21_1 = lazy(tmp_0, UnknownRequest$_anonymous__lw68b2);
}
protoOf(UnknownRequest).m15 = function () {
  return _get_$cachedSerializer__te6jhj_11(this);
};
protoOf(UnknownRequest).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(UnknownRequest).toString = function () {
  return 'UnknownRequest';
};
protoOf(UnknownRequest).hashCode = function () {
  return 371842407;
};
protoOf(UnknownRequest).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof UnknownRequest)) return false;
  other instanceof UnknownRequest || THROW_CCE();
  return true;
};
var UnknownRequest_instance;
function UnknownRequest_getInstance() {
  if (UnknownRequest_instance == null) new UnknownRequest();
  return UnknownRequest_instance;
}
function Companion_28() {}
function $serializer_20() {
  $serializer_instance_19 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.WebCmd.BeginSession', this, 1);
  tmp0_serialDesc.mt('showNavigationHeader', false);
  this.x25_1 = tmp0_serialDesc;
}
protoOf($serializer_20).y25 = function (encoder, value) {
  var tmp0_desc = this.x25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.ln(tmp0_desc, 0, value.b1u_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_20).bj = function (encoder, value) {
  return this.y25(encoder, value instanceof BeginSession ? value : THROW_CCE());
};
protoOf($serializer_20).cj = function (decoder) {
  var tmp0_desc = this.x25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.hm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.hm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return BeginSession_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_20).aj = function () {
  return this.x25_1;
};
protoOf($serializer_20).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 == null) new $serializer_20();
  return $serializer_instance_19;
}
function BeginSession_init_$Init$(seen0, showNavigationHeader, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_19().x25_1);
  }
  $this.b1u_1 = showNavigationHeader;
  return $this;
}
function BeginSession_init_$Create$(seen0, showNavigationHeader, serializationConstructorMarker) {
  return BeginSession_init_$Init$(seen0, showNavigationHeader, serializationConstructorMarker, objectCreate(protoOf(BeginSession)));
}
function Companion_29() {}
function $serializer_21() {
  $serializer_instance_20 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.WebCmd.Connect', this, 1);
  tmp0_serialDesc.mt('args', false);
  this.z25_1 = tmp0_serialDesc;
}
protoOf($serializer_21).a26 = function (encoder, value) {
  var tmp0_desc = this.z25_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.vn(tmp0_desc, 0, $serializer_getInstance_1(), value.b26_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_21).bj = function (encoder, value) {
  return this.a26(encoder, value instanceof Connect ? value : THROW_CCE());
};
protoOf($serializer_21).cj = function (decoder) {
  var tmp0_desc = this.z25_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Connect_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_21).aj = function () {
  return this.z25_1;
};
protoOf($serializer_21).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_1()];
};
var $serializer_instance_20;
function $serializer_getInstance_20() {
  if ($serializer_instance_20 == null) new $serializer_21();
  return $serializer_instance_20;
}
function Connect_init_$Init$(seen0, args, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_20().z25_1);
  }
  $this.b26_1 = args;
  return $this;
}
function Connect_init_$Create$(seen0, args, serializationConstructorMarker) {
  return Connect_init_$Init$(seen0, args, serializationConstructorMarker, objectCreate(protoOf(Connect)));
}
function Companion_30() {
  Companion_instance_30 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.c26_1 = [Companion_getInstance_6().m15()];
}
var Companion_instance_30;
function Companion_getInstance_31() {
  if (Companion_instance_30 == null) new Companion_30();
  return Companion_instance_30;
}
function $serializer_22() {
  $serializer_instance_21 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.WebCmd.EndSession', this, 1);
  tmp0_serialDesc.mt('result', false);
  this.d26_1 = tmp0_serialDesc;
}
protoOf($serializer_22).e26 = function (encoder, value) {
  var tmp0_desc = this.d26_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  var tmp2_cached = Companion_getInstance_31().c26_1;
  tmp1_output.vn(tmp0_desc, 0, tmp2_cached[0], value.z1t_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_22).bj = function (encoder, value) {
  return this.e26(encoder, value instanceof EndSession ? value : THROW_CCE());
};
protoOf($serializer_22).cj = function (decoder) {
  var tmp0_desc = this.d26_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  var tmp6_cached = Companion_getInstance_31().c26_1;
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return EndSession_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_22).aj = function () {
  return this.d26_1;
};
protoOf($serializer_22).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_31().c26_1[0]];
};
var $serializer_instance_21;
function $serializer_getInstance_21() {
  if ($serializer_instance_21 == null) new $serializer_22();
  return $serializer_instance_21;
}
function EndSession_init_$Init$(seen0, result, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_21().d26_1);
  }
  $this.z1t_1 = result;
  return $this;
}
function EndSession_init_$Create$(seen0, result, serializationConstructorMarker) {
  return EndSession_init_$Init$(seen0, result, serializationConstructorMarker, objectCreate(protoOf(EndSession)));
}
function Companion_31() {}
function $serializer_23() {
  $serializer_instance_22 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.WebCmd.Ping', this, 1);
  tmp0_serialDesc.mt('msg', false);
  this.f26_1 = tmp0_serialDesc;
}
protoOf($serializer_23).g26 = function (encoder, value) {
  var tmp0_desc = this.f26_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.tn(tmp0_desc, 0, value.d1u_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_23).bj = function (encoder, value) {
  return this.g26(encoder, value instanceof Ping_0 ? value : THROW_CCE());
};
protoOf($serializer_23).cj = function (decoder) {
  var tmp0_desc = this.f26_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.pm(tmp0_desc, 0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return Ping_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_23).aj = function () {
  return this.f26_1;
};
protoOf($serializer_23).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance_22;
function $serializer_getInstance_22() {
  if ($serializer_instance_22 == null) new $serializer_23();
  return $serializer_instance_22;
}
function Ping_init_$Init$_0(seen0, msg, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_22().f26_1);
  }
  $this.d1u_1 = msg;
  return $this;
}
function Ping_init_$Create$_0(seen0, msg, serializationConstructorMarker) {
  return Ping_init_$Init$_0(seen0, msg, serializationConstructorMarker, objectCreate(protoOf(Ping_0)));
}
function _get_$cachedSerializer__te6jhj_12($this) {
  return $this.h26_1.s1();
}
function WebCmd$GetDigSigAvailability$_anonymous__xvxb7v() {
  var tmp = GetDigSigAvailability_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.req.WebCmd.GetDigSigAvailability', tmp, tmp$ret$2);
}
function _get_$cachedSerializer__te6jhj_13($this) {
  return $this.i26_1.s1();
}
function WebCmd$StartDigSigEnrollment$_anonymous__i0qum8() {
  var tmp = StartDigSigEnrollment_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer_init_$Create$('ipc.req.WebCmd.StartDigSigEnrollment', tmp, tmp$ret$2);
}
function Companion_32() {}
function $serializer_24() {
  $serializer_instance_23 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('ipc.req.WebCmd.GetSignedPayload', this, 1);
  tmp0_serialDesc.mt('data', false);
  this.j26_1 = tmp0_serialDesc;
}
protoOf($serializer_24).k26 = function (encoder, value) {
  var tmp0_desc = this.j26_1;
  var tmp1_output = encoder.fm(tmp0_desc);
  tmp1_output.vn(tmp0_desc, 0, $serializer_getInstance_3(), value.x1t_1);
  tmp1_output.gm(tmp0_desc);
};
protoOf($serializer_24).bj = function (encoder, value) {
  return this.k26(encoder, value instanceof GetSignedPayload ? value : THROW_CCE());
};
protoOf($serializer_24).cj = function (decoder) {
  var tmp0_desc = this.j26_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.fm(tmp0_desc);
  if (tmp5_input.vm()) {
    tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else while (tmp1_flag) {
    tmp2_index = tmp5_input.wm(tmp0_desc);
    switch (tmp2_index) {
      case -1:
        tmp1_flag = false;
        break;
      case 0:
        tmp4_local0 = tmp5_input.rm(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
        tmp3_bitMask0 = tmp3_bitMask0 | 1;
        break;
      default:
        throw UnknownFieldException_init_$Create$(tmp2_index);
    }
  }
  tmp5_input.gm(tmp0_desc);
  return GetSignedPayload_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_24).aj = function () {
  return this.j26_1;
};
protoOf($serializer_24).ot = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [$serializer_getInstance_3()];
};
var $serializer_instance_23;
function $serializer_getInstance_23() {
  if ($serializer_instance_23 == null) new $serializer_24();
  return $serializer_instance_23;
}
function GetSignedPayload_init_$Init$(seen0, data, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_23().j26_1);
  }
  $this.x1t_1 = data;
  return $this;
}
function GetSignedPayload_init_$Create$(seen0, data, serializationConstructorMarker) {
  return GetSignedPayload_init_$Init$(seen0, data, serializationConstructorMarker, objectCreate(protoOf(GetSignedPayload)));
}
function _get_$cachedSerializer__te6jhj_14($this) {
  return $this.l26_1.s1();
}
function WebCmd$Companion$_anonymous__97als9() {
  var tmp = getKClass(WebCmd);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(BeginSession), getKClass(Connect), getKClass(EndSession), getKClass(GetDigSigAvailability), getKClass(GetSignedPayload), getKClass(Ping_0), getKClass(StartDigSigEnrollment)];
  var tmp_1 = $serializer_getInstance_19();
  var tmp_2 = $serializer_getInstance_20();
  var tmp_3 = $serializer_getInstance_21();
  var tmp_4 = GetDigSigAvailability_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [];
  var tmp_5 = ObjectSerializer_init_$Create$('ipc.req.WebCmd.GetDigSigAvailability', tmp_4, tmp$ret$5);
  var tmp_6 = $serializer_getInstance_23();
  var tmp_7 = $serializer_getInstance_22();
  var tmp_8 = StartDigSigEnrollment_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$8 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_9 = [tmp_1, tmp_2, tmp_3, tmp_5, tmp_6, tmp_7, ObjectSerializer_init_$Create$('ipc.req.WebCmd.StartDigSigEnrollment', tmp_8, tmp$ret$8)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$14 = [];
  return SealedClassSerializer_init_$Create$('ipc.req.WebCmd', tmp, tmp_0, tmp_9, tmp$ret$14);
}
function BeginSession(showNavigationHeader) {
  WebCmd.call(this);
  this.b1u_1 = showNavigationHeader;
}
protoOf(BeginSession).toString = function () {
  return 'BeginSession(showNavigationHeader=' + this.b1u_1 + ')';
};
protoOf(BeginSession).hashCode = function () {
  return getBooleanHashCode(this.b1u_1);
};
protoOf(BeginSession).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof BeginSession)) return false;
  var tmp0_other_with_cast = other instanceof BeginSession ? other : THROW_CCE();
  if (!(this.b1u_1 === tmp0_other_with_cast.b1u_1)) return false;
  return true;
};
function Connect(args) {
  WebCmd.call(this);
  this.b26_1 = args;
}
protoOf(Connect).toString = function () {
  return 'Connect(args=' + this.b26_1.toString() + ')';
};
protoOf(Connect).hashCode = function () {
  return this.b26_1.hashCode();
};
protoOf(Connect).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Connect)) return false;
  var tmp0_other_with_cast = other instanceof Connect ? other : THROW_CCE();
  if (!this.b26_1.equals(tmp0_other_with_cast.b26_1)) return false;
  return true;
};
function EndSession(result) {
  Companion_getInstance_31();
  WebCmd.call(this);
  this.z1t_1 = result;
}
protoOf(EndSession).toString = function () {
  return 'EndSession(result=' + toString_1(this.z1t_1) + ')';
};
protoOf(EndSession).hashCode = function () {
  return hashCode(this.z1t_1);
};
protoOf(EndSession).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof EndSession)) return false;
  var tmp0_other_with_cast = other instanceof EndSession ? other : THROW_CCE();
  if (!equals(this.z1t_1, tmp0_other_with_cast.z1t_1)) return false;
  return true;
};
function Ping_0(msg) {
  WebCmd.call(this);
  this.d1u_1 = msg;
}
protoOf(Ping_0).toString = function () {
  return 'Ping(msg=' + this.d1u_1 + ')';
};
protoOf(Ping_0).hashCode = function () {
  return getStringHashCode(this.d1u_1);
};
protoOf(Ping_0).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof Ping_0)) return false;
  var tmp0_other_with_cast = other instanceof Ping_0 ? other : THROW_CCE();
  if (!(this.d1u_1 === tmp0_other_with_cast.d1u_1)) return false;
  return true;
};
function GetDigSigAvailability() {
  GetDigSigAvailability_instance = this;
  WebCmd.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.h26_1 = lazy(tmp_0, WebCmd$GetDigSigAvailability$_anonymous__xvxb7v);
}
protoOf(GetDigSigAvailability).m15 = function () {
  return _get_$cachedSerializer__te6jhj_12(this);
};
protoOf(GetDigSigAvailability).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(GetDigSigAvailability).toString = function () {
  return 'GetDigSigAvailability';
};
protoOf(GetDigSigAvailability).hashCode = function () {
  return 518372890;
};
protoOf(GetDigSigAvailability).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof GetDigSigAvailability)) return false;
  other instanceof GetDigSigAvailability || THROW_CCE();
  return true;
};
var GetDigSigAvailability_instance;
function GetDigSigAvailability_getInstance() {
  if (GetDigSigAvailability_instance == null) new GetDigSigAvailability();
  return GetDigSigAvailability_instance;
}
function StartDigSigEnrollment() {
  StartDigSigEnrollment_instance = this;
  WebCmd.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.i26_1 = lazy(tmp_0, WebCmd$StartDigSigEnrollment$_anonymous__i0qum8);
}
protoOf(StartDigSigEnrollment).m15 = function () {
  return _get_$cachedSerializer__te6jhj_13(this);
};
protoOf(StartDigSigEnrollment).bu = function (typeParamsSerializers) {
  return this.m15();
};
protoOf(StartDigSigEnrollment).toString = function () {
  return 'StartDigSigEnrollment';
};
protoOf(StartDigSigEnrollment).hashCode = function () {
  return 1461650959;
};
protoOf(StartDigSigEnrollment).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof StartDigSigEnrollment)) return false;
  other instanceof StartDigSigEnrollment || THROW_CCE();
  return true;
};
var StartDigSigEnrollment_instance;
function StartDigSigEnrollment_getInstance() {
  if (StartDigSigEnrollment_instance == null) new StartDigSigEnrollment();
  return StartDigSigEnrollment_instance;
}
function GetSignedPayload(data) {
  WebCmd.call(this);
  this.x1t_1 = data;
}
protoOf(GetSignedPayload).toString = function () {
  return 'GetSignedPayload(data=' + this.x1t_1.toString() + ')';
};
protoOf(GetSignedPayload).hashCode = function () {
  return this.x1t_1.hashCode();
};
protoOf(GetSignedPayload).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof GetSignedPayload)) return false;
  var tmp0_other_with_cast = other instanceof GetSignedPayload ? other : THROW_CCE();
  if (!this.x1t_1.equals(tmp0_other_with_cast.x1t_1)) return false;
  return true;
};
function Companion_33() {
  Companion_instance_33 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.l26_1 = lazy(tmp_0, WebCmd$Companion$_anonymous__97als9);
}
protoOf(Companion_33).s25 = function (typeSerial0) {
  return _get_$cachedSerializer__te6jhj_14(this);
};
protoOf(Companion_33).bu = function (typeParamsSerializers) {
  return this.s25(typeParamsSerializers[0]);
};
var Companion_instance_33;
function Companion_getInstance_34() {
  if (Companion_instance_33 == null) new Companion_33();
  return Companion_instance_33;
}
function WebCmd() {
  Companion_getInstance_34();
  IpcRequest.call(this);
}
function DefaultWebCommands$beginSession$slambda($this, $req, resultContinuation) {
  this.u26_1 = $this;
  this.v26_1 = $req;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$beginSession$slambda).x26 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$beginSession$slambda).x8 = function (p1, $completion) {
  return this.x26((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$beginSession$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.u26_1.z26_1.s1s(this.v26_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          return ARGUMENT.orThrow();
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$beginSession$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$beginSession$slambda(this.u26_1, this.v26_1, completion);
  i.w26_1 = $this$promise;
  return i;
};
function DefaultWebCommands$beginSession$slambda_0($this, $req, resultContinuation) {
  var i = new DefaultWebCommands$beginSession$slambda($this, $req, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.x26($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands$ping$slambda(this$0, resultContinuation) {
  this.i27_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$ping$slambda).k27 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$ping$slambda).x8 = function (p1, $completion) {
  return this.k27((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$ping$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.i27_1.z26_1.s1s(new Ping_0('Ping from web!'), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var this_0 = suspendResult;
          var tmp_0;
          if (this_0 instanceof Success_0) {
            tmp_0 = this_0.data.msg;
          } else {
            if (this_0 instanceof Failure) {
              throw new IpcErrorException(this_0.error);
            } else {
              noWhenBranchMatchedException();
            }
          }
          return tmp_0;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$ping$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$ping$slambda(this.i27_1, completion);
  i.j27_1 = $this$promise;
  return i;
};
function DefaultWebCommands$ping$slambda_0(this$0, resultContinuation) {
  var i = new DefaultWebCommands$ping$slambda(this$0, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.k27($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands$generateError$slambda($this, $req, resultContinuation) {
  this.t27_1 = $this;
  this.u27_1 = $req;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$generateError$slambda).x26 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$generateError$slambda).x8 = function (p1, $completion) {
  return this.x26((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$generateError$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.t27_1.z26_1.s1s(this.u27_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          return ARGUMENT.orThrow();
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$generateError$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$generateError$slambda(this.t27_1, this.u27_1, completion);
  i.v27_1 = $this$promise;
  return i;
};
function DefaultWebCommands$generateError$slambda_0($this, $req, resultContinuation) {
  var i = new DefaultWebCommands$generateError$slambda($this, $req, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.x26($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands$endSession$slambda(this$0, $result, resultContinuation) {
  this.e28_1 = this$0;
  this.f28_1 = $result;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$endSession$slambda).x26 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$endSession$slambda).x8 = function (p1, $completion) {
  return this.x26((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$endSession$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.e28_1.z26_1.s1s(new EndSession(this.f28_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var this_0 = suspendResult;
          var tmp_0;
          if (this_0 instanceof Success_0) {
            this_0.data;
            tmp_0 = IpcVoid_getInstance();
          } else {
            if (this_0 instanceof Failure) {
              throw new IpcErrorException(this_0.error);
            } else {
              noWhenBranchMatchedException();
            }
          }
          return tmp_0;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$endSession$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$endSession$slambda(this.e28_1, this.f28_1, completion);
  i.g28_1 = $this$promise;
  return i;
};
function DefaultWebCommands$endSession$slambda_0(this$0, $result, resultContinuation) {
  var i = new DefaultWebCommands$endSession$slambda(this$0, $result, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.x26($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands$getDigSigAvailability$slambda(this$0, resultContinuation) {
  this.p28_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$getDigSigAvailability$slambda).r28 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$getDigSigAvailability$slambda).x8 = function (p1, $completion) {
  return this.r28((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$getDigSigAvailability$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.p28_1.z26_1.s1s(GetDigSigAvailability_getInstance(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var this_0 = suspendResult;
          var tmp_0;
          if (this_0 instanceof Success_0) {
            tmp_0 = this_0.data;
          } else {
            if (this_0 instanceof Failure) {
              throw new IpcErrorException(this_0.error);
            } else {
              noWhenBranchMatchedException();
            }
          }
          return tmp_0;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$getDigSigAvailability$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$getDigSigAvailability$slambda(this.p28_1, completion);
  i.q28_1 = $this$promise;
  return i;
};
function DefaultWebCommands$getDigSigAvailability$slambda_0(this$0, resultContinuation) {
  var i = new DefaultWebCommands$getDigSigAvailability$slambda(this$0, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.r28($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands$getDigSigSignature$slambda(this$0, $data, resultContinuation) {
  this.a29_1 = this$0;
  this.b29_1 = $data;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebCommands$getDigSigSignature$slambda).k27 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(DefaultWebCommands$getDigSigSignature$slambda).x8 = function (p1, $completion) {
  return this.k27((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebCommands$getDigSigSignature$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.a29_1.z26_1.s1s(new GetSignedPayload(new SignPayloadData(this.b29_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var this_0 = suspendResult;
          var tmp_0;
          if (this_0 instanceof Success_0) {
            tmp_0 = this_0.data.signature;
          } else {
            if (this_0 instanceof Failure) {
              throw new IpcErrorException(this_0.error);
            } else {
              noWhenBranchMatchedException();
            }
          }
          return tmp_0;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(DefaultWebCommands$getDigSigSignature$slambda).p1x = function ($this$promise, completion) {
  var i = new DefaultWebCommands$getDigSigSignature$slambda(this.a29_1, this.b29_1, completion);
  i.c29_1 = $this$promise;
  return i;
};
function DefaultWebCommands$getDigSigSignature$slambda_0(this$0, $data, resultContinuation) {
  var i = new DefaultWebCommands$getDigSigSignature$slambda(this$0, $data, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.k27($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebCommands(scope, connection) {
  this.y26_1 = scope;
  this.z26_1 = connection;
}
protoOf(DefaultWebCommands).beginSession = function (showNativeHeader) {
  // Inline function 'com.verisure.mymobile.myipc.DefaultWebCommands.request' call
  var req = new BeginSession(showNativeHeader);
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$beginSession$slambda_0(this, req, null));
};
protoOf(DefaultWebCommands).ping = function () {
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$ping$slambda_0(this, null));
};
protoOf(DefaultWebCommands).generateError = function (error) {
  // Inline function 'com.verisure.mymobile.myipc.DefaultWebCommands.request' call
  var req = new IpcDebugErrorRequest(error);
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$generateError$slambda_0(this, req, null));
};
protoOf(DefaultWebCommands).d29 = function (result) {
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$endSession$slambda_0(this, result, null));
};
protoOf(DefaultWebCommands).getDigSigAvailability = function () {
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$getDigSigAvailability$slambda_0(this, null));
};
protoOf(DefaultWebCommands).getDigSigSignature = function (data) {
  return promise(this.y26_1, VOID, VOID, DefaultWebCommands$getDigSigSignature$slambda_0(this, data, null));
};
function JsIpcConnection() {}
function DefaultJsIpcConnection(scope, connection, appInfo) {
  this.f29_1 = appInfo;
  this.g29_1 = new DefaultWebCommands(scope, connection);
}
protoOf(DefaultJsIpcConnection).e29 = function () {
  return this.f29_1;
};
protoOf(DefaultJsIpcConnection).n21 = function () {
  return this.g29_1;
};
function hookRxChannel($this) {
  window.top.jsipc = window.top.jsipc || {};
  // Inline function 'kotlin.js.asDynamic' call
  window.top['jsipc'][$this.h29_1] = JsReceiveFromNativeChannel$onReceive$ref($this);
}
function onReceive($this, msg) {
  console.log('Web Rx msg: ' + msg);
  $this.i29_1(msg);
}
function JsReceiveFromNativeChannel$onReceive$ref($boundThis) {
  var l = function l(p0) {
    onReceive($boundThis, p0);
    return Unit_instance;
  };
  l.callableName = 'onReceive';
  return l;
}
function JsReceiveFromNativeChannel(receiverId, receiver) {
  this.h29_1 = receiverId;
  this.i29_1 = receiver;
  hookRxChannel(this);
}
function _get_txChannel__gttw0i($this) {
  var tmp = $this.j29_1;
  if (!(tmp == null)) return tmp;else {
    throwUninitializedPropertyAccessException('txChannel');
  }
}
function hookTxChannel($this) {
  try {
    var available = typeof webkit.messageHandlers.interop.postMessage === 'function';
    if (available) {
      console.log('Found txChannel for iOS, hooking up: webkit.messageHandlers.interop.postMessage');
      var tmp = $this;
      tmp.j29_1 = JsSendToNativeChannel$hookTxChannel$lambda;
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      console.log('Getting iOS sink failed. Searched for: webkit.messageHandlers.interop.postMessage', e);
    } else {
      throw $p;
    }
  }
  try {
    var available_0 = typeof nativeipc.notify === 'function';
    if (available_0) {
      console.log('Android bridge available, hooking up: nativeipc.notify');
      var tmp_0 = $this;
      tmp_0.j29_1 = JsSendToNativeChannel$hookTxChannel$lambda_0;
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e_0 = $p;
      console.log('Getting Android sink failed. Searched for: nativeipc.notify', e_0);
    } else {
      throw $p;
    }
  }
  try {
    var available_1 = typeof myIpcAppReceiver === 'function';
    if (available_1) {
      console.log('Found txChannel myIpcAppReceiver');
      var tmp_1 = $this;
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_2 = window['myIpcAppReceiver'];
      tmp_1.j29_1 = (!(tmp_2 == null) ? typeof tmp_2 === 'function' : false) ? tmp_2 : THROW_CCE();
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e_1 = $p;
      console.log('Error getting fake sink. Searched for: myIpcAppReceiver available?', e_1);
    } else {
      throw $p;
    }
  }
  console.error('No tx channel found.');
}
function JsSendToNativeChannel$hookTxChannel$lambda(msg) {
  // Inline function 'org.w3c.dom.get' call
  // Inline function 'kotlin.js.asDynamic' call
  window['webkit']['messageHandlers']['interop']['postMessage'](msg);
  return Unit_instance;
}
function JsSendToNativeChannel$hookTxChannel$lambda_0(msg) {
  // Inline function 'org.w3c.dom.get' call
  // Inline function 'kotlin.js.asDynamic' call
  window['nativeipc']['notify'](msg);
  return Unit_instance;
}
function JsSendToNativeChannel() {
  hookTxChannel(this);
}
protoOf(JsSendToNativeChannel).k29 = function (msg) {
  try {
    _get_txChannel__gttw0i(this)(msg);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      console.error('Error sending IPC message', e);
    } else {
      throw $p;
    }
  }
};
function WebCommands() {}
function randomId($this, length) {
  var alphabet = plus_0(plus_1(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list = ArrayList_init_$Create$_0(length);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < length) do {
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.MutableList.<anonymous>' call
    // Inline function 'com.verisure.mymobile.myipc.WebIpcClient.randomId.<anonymous>' call
    // Inline function 'kotlin.collections.random' call
    var tmp$ret$0 = random(alphabet, Default_getInstance()).c1_1;
    var tmp$ret$1 = new Char(tmp$ret$0);
    list.d(tmp$ret$1);
  } while (inductionVariable < length);
  return joinToString_0(list, '');
}
function WebIpcClient$connect$lambda($txChannel, $connectionId) {
  return function (it) {
    $txChannel.k29(IpcJson_instance.g21(it.t21($connectionId)));
    return Unit_instance;
  };
}
function WebIpcClient$connect$lambda_0($connection) {
  return function (it) {
    var tmp;
    try {
      var frame = IpcJson_instance.j21(it);
      $connection.x20(frame);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function WebIpcClient$connect$slambda($connection, this$0, resultContinuation) {
  this.t29_1 = $connection;
  this.u29_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebIpcClient$connect$slambda).w29 = function ($this$promise, $completion) {
  var tmp = this.p1x($this$promise, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(WebIpcClient$connect$slambda).x8 = function (p1, $completion) {
  return this.w29((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebIpcClient$connect$slambda).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 2;
          this.t7_1 = 1;
          suspendResult = this.t29_1.s1s(new Connect(new ConnectArgs(0)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          var this_0 = suspendResult;
          var tmp_0;
          if (this_0 instanceof Success_0) {
            var it = this_0.data;
            tmp_0 = new DefaultJsIpcConnection(this.u29_1.x29_1, this.t29_1, it.c25_1);
          } else {
            if (this_0 instanceof Failure) {
              throw new IpcErrorException(this_0.error);
            } else {
              noWhenBranchMatchedException();
            }
          }
          return tmp_0;
        case 2:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 2) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf(WebIpcClient$connect$slambda).p1x = function ($this$promise, completion) {
  var i = new WebIpcClient$connect$slambda(this.t29_1, this.u29_1, completion);
  i.v29_1 = $this$promise;
  return i;
};
function WebIpcClient$connect$slambda_0($connection, this$0, resultContinuation) {
  var i = new WebIpcClient$connect$slambda($connection, this$0, resultContinuation);
  var l = function l($this$promise, $completion) {
    return i.w29($this$promise, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebIpcClient() {
  this.x29_1 = CoroutineScope_0(SupervisorJob());
}
protoOf(WebIpcClient).connect = function (commandHandler) {
  var connectionId = randomId(this, 6);
  var txChannel = new JsSendToNativeChannel();
  var connection = new IpcConnection(this.x29_1, WebIpcClient$connect$lambda(txChannel, connectionId), new IpcClientRequestHandler(new WebIpcHandlerPromiseAdapter(commandHandler)));
  new JsReceiveFromNativeChannel(connectionId, WebIpcClient$connect$lambda_0(connection));
  return promise(this.x29_1, VOID, VOID, WebIpcClient$connect$slambda_0(connection, this, null));
};
function $onPingCOROUTINE$7(_this__u8e3s4, msg, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g2a_1 = _this__u8e3s4;
  this.h2a_1 = msg;
}
protoOf($onPingCOROUTINE$7).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 3;
          var tmp_0 = this;
          var tmp0_safe_receiver = _get_host__d7qftv(this.g2a_1.k2a_1).k21();
          tmp_0.i2a_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n21();
          if (this.i2a_1 == null) {
            this.j2a_1 = null;
            this.t7_1 = 2;
            continue $sm;
          } else {
            this.t7_1 = 1;
            suspendResult = this.i2a_1.l1s('Pingback', this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }
        case 1:
          this.j2a_1 = suspendResult;
          this.t7_1 = 2;
          continue $sm;
        case 2:
          return new Success_0(new IpcPingReply('Pong: ' + this.h2a_1));
        case 3:
          throw this.w7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.u7_1 === 3) {
        throw e;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e;
      }
    }
  } while (true);
};
protoOf($onPingCOROUTINE$7)['<set-state>'] = protoOf($onPingCOROUTINE$7).a8;
protoOf($onPingCOROUTINE$7)['<get-state>'] = protoOf($onPingCOROUTINE$7).b8;
protoOf($onPingCOROUTINE$7)['<set-exceptionState>'] = protoOf($onPingCOROUTINE$7).c8;
protoOf($onPingCOROUTINE$7)['<get-exceptionState>'] = protoOf($onPingCOROUTINE$7).d8;
protoOf($onPingCOROUTINE$7)['<set-result>'] = protoOf($onPingCOROUTINE$7).e8;
protoOf($onPingCOROUTINE$7)['<get-result>'] = protoOf($onPingCOROUTINE$7).f8;
protoOf($onPingCOROUTINE$7)['<set-exception>'] = protoOf($onPingCOROUTINE$7).g8;
protoOf($onPingCOROUTINE$7)['<get-exception>'] = protoOf($onPingCOROUTINE$7).h8;
protoOf($onPingCOROUTINE$7)['<set-finallyPath>'] = protoOf($onPingCOROUTINE$7).i8;
protoOf($onPingCOROUTINE$7)['<get-finallyPath>'] = protoOf($onPingCOROUTINE$7).j8;
protoOf($onPingCOROUTINE$7)['<get-context>'] = protoOf($onPingCOROUTINE$7).z7;
function _get_host__d7qftv($this) {
  var tmp0 = $this.o2a_1;
  // Inline function 'kotlin.getValue' call
  host$factory();
  return tmp0.s1();
}
function WebIpcFakeApp$txChannel$1() {
  IpcTxToWebChannel.call(this);
}
protoOf(WebIpcFakeApp$txChannel$1).h21 = function (receiver, msg) {
  // Inline function 'kotlin.js.asDynamic' call
  window['jsipc'][receiver](msg);
};
function WebIpcFakeApp$requestHandler$1(this$0) {
  this.k2a_1 = this$0;
}
protoOf(WebIpcFakeApp$requestHandler$1).e1u = function (msg, $completion) {
  var tmp = new $onPingCOROUTINE$7(this, msg, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
};
protoOf(WebIpcFakeApp$requestHandler$1).c1u = function (showNavigationHeader, $completion) {
  console.log('Web booted.');
  return new Success_0(IpcVoid_getInstance());
};
protoOf(WebIpcFakeApp$requestHandler$1).a1u = function (result, $completion) {
  return new Success_0(IpcVoid_getInstance());
};
protoOf(WebIpcFakeApp$requestHandler$1).y1t = function (data, $completion) {
  return new Failure(Unsupported_getInstance());
};
protoOf(WebIpcFakeApp$requestHandler$1).w1t = function ($completion) {
  return new Failure(Unsupported_getInstance());
};
protoOf(WebIpcFakeApp$requestHandler$1).v1t = function ($completion) {
  return new Failure(Unsupported_getInstance());
};
function WebIpcFakeApp$host$delegate$lambda$lambda(this$0) {
  return function (it) {
    return this$0.n2a_1;
  };
}
function WebIpcFakeApp$host$delegate$lambda(this$0) {
  return function () {
    return new IpcHost(this$0.l2a_1, this$0.m2a_1, WebIpcFakeApp$host$delegate$lambda$lambda(this$0));
  };
}
function WebIpcFakeApp$onReceive$ref($boundThis) {
  var l = function l(p0) {
    $boundThis.onReceive(p0);
    return Unit_instance;
  };
  l.callableName = 'onReceive';
  return l;
}
function WebIpcFakeApp() {
  this.l2a_1 = CoroutineScope_0(SupervisorJob());
  var tmp = this;
  tmp.m2a_1 = new WebIpcFakeApp$txChannel$1();
  var tmp_0 = this;
  var tmp_1 = new AppConnectInfo(new AppDebugInfo('FakeApp', '1.0.0'), new AppFeatureManifest(true));
  tmp_0.n2a_1 = new IpcHostRequestHandler(tmp_1, new WebIpcFakeApp$requestHandler$1(this));
  var tmp_2 = this;
  tmp_2.o2a_1 = lazy_0(WebIpcFakeApp$host$delegate$lambda(this));
  // Inline function 'kotlin.js.asDynamic' call
  window['myIpcAppReceiver'] = WebIpcFakeApp$onReceive$ref(this);
}
protoOf(WebIpcFakeApp).onReceive = function (msg) {
  console.log('FakeIPC Rx: ' + msg);
  _get_host__d7qftv(this).i21(msg);
};
function host$factory() {
  return getPropertyCallableRef('host', 1, KProperty1, function (receiver) {
    return _get_host__d7qftv(receiver);
  }, null);
}
function wrap(_this__u8e3s4, $this, $completion) {
  var tmp = _this__u8e3s4.then(WebIpcHandlerPromiseAdapter$wrap$lambda);
  return await_0(tmp["catch"](WebIpcHandlerPromiseAdapter$wrap$lambda_0), $completion);
}
function WebIpcHandlerPromiseAdapter$wrap$lambda(it) {
  return new Success_0(it);
}
function WebIpcHandlerPromiseAdapter$wrap$lambda_0(it) {
  var tmp0_elvis_lhs = it instanceof IpcError ? it : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = it instanceof IpcErrorException ? it : null;
    tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ipcError;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp2_elvis_lhs = tmp;
  return new Failure(tmp2_elvis_lhs == null ? new Generic('Web threw: ' + it.toString()) : tmp2_elvis_lhs);
}
function WebIpcHandlerPromiseAdapter(js) {
  this.p2a_1 = js;
}
protoOf(WebIpcHandlerPromiseAdapter).e1u = function (msg, $completion) {
  return wrap(this.p2a_1.onPing(msg), this, $completion);
};
//region block: post-declaration
protoOf($serializer).pt = typeParametersSerializers;
defineProp(protoOf(Companion_0), '$cachedDescriptor', protoOf(Companion_0).h22);
protoOf($serializer_1).pt = typeParametersSerializers;
protoOf($serializer_2).pt = typeParametersSerializers;
protoOf($serializer_3).pt = typeParametersSerializers;
protoOf($serializer_4).pt = typeParametersSerializers;
protoOf($serializer_5).pt = typeParametersSerializers;
protoOf($serializer_6).pt = typeParametersSerializers;
protoOf($serializer_7).pt = typeParametersSerializers;
protoOf($serializer_8).pt = typeParametersSerializers;
protoOf($serializer_9).pt = typeParametersSerializers;
protoOf($serializer_10).pt = typeParametersSerializers;
protoOf($serializer_11).pt = typeParametersSerializers;
protoOf($serializer_12).pt = typeParametersSerializers;
protoOf($serializer_13).pt = typeParametersSerializers;
protoOf($serializer_14).pt = typeParametersSerializers;
protoOf($serializer_15).pt = typeParametersSerializers;
protoOf($serializer_16).pt = typeParametersSerializers;
protoOf($serializer_17).pt = typeParametersSerializers;
protoOf($serializer_18).pt = typeParametersSerializers;
protoOf($serializer_19).pt = typeParametersSerializers;
protoOf($serializer_20).pt = typeParametersSerializers;
protoOf($serializer_21).pt = typeParametersSerializers;
protoOf($serializer_22).pt = typeParametersSerializers;
protoOf($serializer_23).pt = typeParametersSerializers;
protoOf($serializer_24).pt = typeParametersSerializers;
protoOf(DefaultWebCommands).endSession = endSession;
defineProp(protoOf(DefaultJsIpcConnection), 'appInfo', function () {
  return this.e29();
});
defineProp(protoOf(DefaultJsIpcConnection), 'commands', function () {
  return this.n21();
});
//endregion
//region block: init
IpcJson_instance = new IpcJson();
Companion_instance_4 = new Companion_4();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_12 = new Companion_12();
Companion_instance_15 = new Companion_15();
Companion_instance_16 = new Companion_16();
Companion_instance_17 = new Companion_17();
Companion_instance_18 = new Companion_18();
Companion_instance_20 = new Companion_20();
Companion_instance_21 = new Companion_21();
Companion_instance_22 = new Companion_22();
Companion_instance_23 = new Companion_23();
//endregion
//region block: exports
defineProp(IpcDecodeFrameResult, 'Success', Success_getInstance);
IpcDecodeFrameResult.Failed = Failed;
IpcResult.Success = Success_0;
defineProp(IpcResult.Success, 'Companion', Companion_getInstance_1);
IpcResult.Failure = Failure;
defineProp(IpcResult.Failure, 'Companion', Companion_getInstance_2);
defineProp(IpcResult, 'Companion', Companion_getInstance_3);
defineProp(EndResult, 'GoBack', GoBack_getInstance);
EndResult.GoHome = GoHome;
defineProp(EndResult.GoHome, 'Companion', Companion_getInstance_5);
defineProp(EndResult, 'Unknown', Unknown_getInstance);
defineProp(EndResult, 'Companion', Companion_getInstance_6);
defineProp(SignPayloadData, 'Companion', Companion_getInstance_7);
IpcError.Generic = Generic;
defineProp(IpcError.Generic, 'Companion', Companion_getInstance_8);
IpcError.Interop = Interop;
IpcError.Interop.InvalidRequest = InvalidRequest;
defineProp(IpcError.Interop.InvalidRequest, 'Companion', Companion_getInstance_9);
IpcError.Interop.Timeout = Timeout;
defineProp(IpcError.Interop.Timeout, 'Companion', Companion_getInstance_10);
IpcError.Interop.HandlerException = HandlerException;
defineProp(IpcError.Interop.HandlerException, 'Companion', Companion_getInstance_11);
defineProp(IpcError.Interop, 'Unsupported', Unsupported_getInstance);
defineProp(IpcError.Interop, 'UnknownResponseError', UnknownResponseError_getInstance);
defineProp(IpcError.Interop, 'Companion', Companion_getInstance_12);
IpcError.Network = Network;
IpcError.Network.Unknown = Unknown_0;
defineProp(IpcError.Network.Unknown, 'Companion', Companion_getInstance_13);
defineProp(IpcError.Network, 'Companion', Companion_getInstance_14);
defineProp(IpcError, 'Companion', Companion_getInstance_15);
defineProp(AppConnectInfo, 'Companion', Companion_getInstance_16);
defineProp(AppDebugInfo, 'Companion', Companion_getInstance_17);
defineProp(AppFeatureManifest, 'Companion', Companion_getInstance_18);
defineProp(BiometricFeatures, 'Companion', Companion_getInstance_19);
defineProp(IpcDigSigAvailabilityReply, 'Companion', Companion_getInstance_21);
defineProp(IpcDigSigSignPayloadReply, 'Companion', Companion_getInstance_22);
defineProp(IpcPingReply, 'Companion', Companion_getInstance_23);
//endregion

export { AppConnectInfo, AppDebugInfo, AppFeatureManifest, BiometricFeatures, EndResult, IpcDecodeFrameResult, IpcDigSigAvailabilityReply, IpcDigSigSignPayloadReply, IpcError, IpcErrorException, IpcPingReply, IpcResult, SignPayloadData, WebIpcClient, WebIpcFakeApp };
